import { CardBody } from "@material-tailwind/react";
import React, { useEffect, useRef, useState } from "react";
import { SearchBarSmall, SearchBarSmallV2 } from "../form/SearchBar";
import Skeltons from "../loading/Skeltons";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { maxPageGlobal } from "../../assets/config";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { v4 as uuidv4 } from "uuid";

export default function DynamicTable(props) {
  const tableRef = useRef(null);

  let many = 0;
  if (props.data) {
    many = props.data.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }

  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <DownloadTableExcel
                filename={"Report_" + props.title + "xlsx"}
                sheet="users"
                currentTableRef={tableRef.current}
              >
                <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                  {" "}
                  Download Excel
                </button>
              </DownloadTableExcel>
            )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmall
              text={"Cari " + props.name}
              funcs={props.menuController}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          // Format kolom angka mengikuti Buku Besar: bilangan bulat
                          // dengan pemisah ribuan id-ID (mis. 9.071.229.331).
                          if (props.header[idRow]["modifiers"] === "Number ") {
                            texts = Math.round(
                              parseFloat(detail[props.header[idRow]["key"]] || 0)
                            ).toLocaleString("id-ID", { maximumFractionDigits: 0 });
                          }

                          switch (props.header[idRow]["modifiers"]) {
                            case "Izin":
                              if (texts === "1") {
                                texts = "Pulang Cepat";
                              } else if (texts === "2") {
                                texts = "Terlambat Datang";
                              } else if (texts === "3") {
                                texts = "Keluar Jam Kerja";
                              } else if (texts === "4") {
                                texts = "Tidak masuk kerja";
                              }
                              break;
                            case "JenisTiket":
                              if (texts === "1") {
                                texts = "Darat";
                              } else if (texts === "2") {
                                texts = "Laut";
                              } else if (texts === "3") {
                                texts = "Udara";
                              }
                              break;
                            case "DasarPermohonan":
                              if (texts === "1") {
                                texts = "Cuti";
                              } else if (texts === "2") {
                                texts = "Perjalanan Dinas";
                              } else if (texts === "3") {
                                texts = "Training";
                              }
                              break;
                            case "JenisRawat":
                              if (texts === "1") {
                                texts = "Rawat Jalan";
                              } else if (texts === "2") {
                                texts = "Rawat Inap";
                              } else if (texts === "3") {
                                texts = "Operasi";
                              }
                              break;
                            case "JenisKelamin":
                              if (texts === 1) {
                                texts = "Pria";
                              } else if (texts === 0) {
                                texts = "Wanita";
                              }
                              break;
                            case "Pendidikan":
                              if (texts === "1") {
                                texts = "SD";
                              } else if (texts === "2") {
                                texts = "SMP";
                              } else if (texts === "3") {
                                texts = "SMA / SMK";
                              } else if (texts === "4") {
                                texts = "D1";
                              } else if (texts === "5") {
                                texts = "D2";
                              } else if (texts === "6") {
                                texts = "D3";
                              } else if (texts === "7") {
                                texts = "S1";
                              } else if (texts === "8") {
                                texts = "S2";
                              } else if (texts === "9") {
                                texts = "S3";
                              }
                              break;
                            case "StatusPerkawinan":
                              if (texts === "1") {
                                texts = "Belum Menikah";
                              } else if (texts === "2") {
                                texts = "Menikah";
                              }
                              break;
                            case "WargaNegara":
                              if (texts === "1") {
                                texts = "Indonesia";
                              } else if (texts === "2") {
                                texts = "Asing";
                              }
                              break;
                            case "Agama":
                              if (texts === 1) {
                                texts = "Islam";
                              } else if (texts === 2) {
                                texts = "Protestan";
                              } else if (texts === 3) {
                                texts = "Katolik";
                              } else if (texts === 4) {
                                texts = "Hindu";
                              } else if (texts === 5) {
                                texts = "Buddha";
                              } else if (texts === 6) {
                                texts = "Khonghucu";
                              }
                              break;
                            case "SistemGaji":
                              if (texts === 1) {
                                texts = "Transfer";
                              } else if (texts === 2) {
                                texts = "Cash";
                              }
                              break;
                            case "Status":
                              if (texts === "1") {
                                texts = "Aktif";
                              } else if (texts === "2") {
                                texts = "Non-Active";
                              }
                              break;
                            case "StatusPajak":
                              switch (texts) {
                                case "1":
                                  texts = "TK0";
                                  break;
                                case "2":
                                  texts = "TK1";
                                  break;
                                case "3":
                                  texts = "TK2";
                                  break;
                                case "4":
                                  texts = "TK3";
                                  break;
                                case "5":
                                  texts = "K0";
                                  break;
                                case "6":
                                  texts = "K1";
                                  break;
                                case "7":
                                  texts = "K2";
                                  break;
                                case "8":
                                  texts = "K3";
                                  break;
                              }
                          }
                          return (
                            <th
                              scope="row"
                              key={"row" + id + "-" + idRow}
                              className={
                                "py-4 px-6 font-medium whitespace-nowrap " +
                                (props.header[idRow]["modifiers"] === "Number "
                                  ? "text-right"
                                  : "text-left ") +
                                (props.header[idRow]["modifiers"] !== "Status"
                                  ? "text-black"
                                  : "text-main-100")
                              }
                            >
                              {texts}
                            </th>
                          );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTablev2(props) {
  const navigate = useNavigate();
  const tableRef = useRef(null);

  // State untuk data dan search
  const [displayData, setDisplayData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchValue, setSearchValue] = useState(props.searchValue || "");

  // Load data dari props
  useEffect(() => {
    let dataArray = [];
    if (Array.isArray(props.data)) {
      dataArray = props.data;
    } else if (props.data && props.data.data) {
      dataArray = props.data.data;
    }

    setOriginalData(dataArray || []);
    setDisplayData(dataArray || []);
  }, [props.data]);

  // Filter data berdasarkan search value
  useEffect(() => {
    if (!searchValue.trim()) {
      setDisplayData(originalData);
      return;
    }

    const filtered = originalData.filter((item) => {
      return Object.keys(item).some((key) => {
        const value = item[key];
        if (value && typeof value === "string") {
          return value.toLowerCase().includes(searchValue.toLowerCase());
        }
        // Handle number dan tipe data lain
        if (value !== null && value !== undefined) {
          return value
            .toString()
            .toLowerCase()
            .includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setDisplayData(filtered);
  }, [searchValue, originalData]);

  // Handler untuk search input
  const handleSearch = (event) => {
    setSearchValue(event.target.value);

    // Jika ada prop menuController dari parent, panggil juga
    if (props.menuController) {
      props.menuController(event);
    }
  };

  // Handler untuk clear search
  const handleClearSearch = () => {
    setSearchValue("");
    setDisplayData(originalData);
  };

  let many = displayData.length;
  let Yscroll = many > 20 ? "h-screen" : "";

  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick && props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <DownloadTableExcel
                filename={"PENGELUARAN KAS_" + "Data"}
                sheet="Sheet1"
                currentTableRef={tableRef.current}
              >
                <button
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={displayData.length === 0}
                >
                  Download Excel
                </button>
              </DownloadTableExcel>
            )}
          </div>
          <div className="flex flex-row w-96 items-center gap-2">
            <div className="flex-1">
              <SearchBarSmall
                text={"Cari " + (props.name || "data")}
                funcs={handleSearch}
                value={searchValue}
              />
            </div>
            {searchValue && (
              <button
                onClick={handleClearSearch}
                className="text-gray-500 hover:text-gray-700 text-sm"
                title="Clear search"
              >
                Clear
              </button>
            )}
            {searchValue && (
              <div className="text-sm text-gray-600">
                {displayData.length} hasil
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0">
        {props.isLoading ? (
          <Skeltons />
        ) : displayData.length > 0 ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {props.header &&
                    props.header.map((data, id) => (
                      <th
                        scope="col"
                        className="py-3 px-6"
                        key={"Header-" + id}
                      >
                        {data.name}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {displayData.map((detail, id) => {
                  const classOdd =
                    id % 2 === 0
                      ? "bg-white border-b hover:bg-gray-200"
                      : "bg-gray-50 border-b hover:bg-gray-200";

                  return (
                    <tr className={classOdd} key={`row-${id}`}>
                      {props.header &&
                        props.header.map((data, idRow) => {
                          let cellValue = detail[data.key];

                          // Format tanggal
                          if (data.modifiers === "Date" && cellValue) {
                            try {
                              cellValue = new Date(
                                cellValue
                              ).toLocaleDateString("ID");
                            } catch (e) {
                              cellValue = cellValue || "";
                            }
                            if (cellValue === "Invalid Date") {
                              cellValue = "";
                            }
                          }

                          // Format angka
                          if (data.modifiers === "Number" && cellValue) {
                            cellValue = parseFloat(cellValue).toLocaleString(
                              "in-ID",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            );
                          }

                          // Render tombol detail
                          if (data.modifiers === "DetailNonPO") {
                            const cashJournalId = detail["CashJournalID"] || "";
                            const dataDetail = cashJournalId
                              .toString()
                              .replace(/\//g, "-");

                            return (
                              <td
                                key={`cell-${id}-${idRow}`}
                                className="py-4 px-6"
                              >
                                <div className="flex flex-wrap gap-2">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(
                                        `/finance/detail/form-kas-bank/${dataDetail}`
                                      );
                                    }}
                                    className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-1.5 focus:outline-none"
                                  >
                                    Lihat
                                  </button>
                                  {detail["Status"] === "Approved" && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(
                                          `/finance/report/blanco/pembayaran-non-po/${dataDetail}`
                                        );
                                      }}
                                      className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-1.5 focus:outline-none"
                                    >
                                      Blanko
                                    </button>
                                  )}
                                </div>
                              </td>
                            );
                          }

                          // Render teks biasa
                          return (
                            <td
                              key={`cell-${id}-${idRow}`}
                              className={`py-4 px-6 font-medium whitespace-nowrap ${
                                data.modifiers === "Number"
                                  ? "text-right"
                                  : "text-left"
                              }`}
                            >
                              {cellValue || ""}
                            </td>
                          );
                        })}
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {/* Info hasil pencarian */}
            {searchValue && (
              <div className="mt-4 text-sm text-gray-600">
                Menampilkan {displayData.length} dari {originalData.length} data
                {displayData.length === 0 && (
                  <div className="text-red-500 mt-2">
                    Tidak ada data yang cocok dengan pencarian "{searchValue}"
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-8">
            {props.isLoading ? (
              <Skeltons />
            ) : searchValue ? (
              <>
                <div className="text-gray-500 mb-2">
                  Tidak ada data yang cocok dengan pencarian "{searchValue}"
                </div>
                <button
                  onClick={handleClearSearch}
                  className="text-main-100 hover:text-main-200 font-medium"
                >
                  Tampilkan semua data
                </button>
              </>
            ) : (
              "Tidak ada data yang ditemukan"
            )}
          </div>
        )}
      </CardBody>
    </>
  );
}

const splitStringByWidth = (inputString, maxWidth) => {
  const MAX_WIDTH = maxWidth;
  const words = inputString.split(" ");
  let currentLine = words[0];
  let result = "";

  for (let i = 1; i < words.length; i++) {
    const word = words[i];
    const tempLine = `${currentLine} ${word}`;

    if (tempLine.length > MAX_WIDTH) {
      result += currentLine + "\n";
      currentLine = word;
    } else {
      currentLine = tempLine;
    }
  }

  result += currentLine;
  return result;
};

export function DynamicTablev3(props) {
  const navigate = useNavigate();

  const tableRef = useRef(null);

  let many = 0;
  if (props.data) {
    many = props.data.length;
  }
  const randomUUID = uuidv4();

  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <DownloadTableExcel
                filename={"Report_" + props.title + randomUUID}
                sheet="data"
                currentTableRef={tableRef.current}
              >
                <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                  {" "}
                  Download Excel
                </button>
              </DownloadTableExcel>
            )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmallV2
              text={"Cari " + props.name}
              value={props.value}
              funcs={props.menuController}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      {props.data ? (
        <div className={"hidden"} style={{ maxHeight: "600px" }}>
          <table
            className="text-sm text-left text-gray-500  mt-10  w-full"
            ref={tableRef}
          >
            <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
              <tr>
                {props.header.map((data, id) => {
                  if (data.name !== "Action") {
                    return (
                      <th
                        scope="col"
                        className="py-3 px-6"
                        key={"Headerpint-" + id}
                      >
                        {data.name}
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {props.data.data &&
                props.data.data.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";

                  return (
                    <tr className={classOdd} key={"pintdata-" + id}>
                      {props.header.map((data, idRow) => {
                        let texts = detail[props.header[idRow]["key"]];
                        if (props.header[idRow]["modifiers"] === "Date") {
                          texts = new Date(
                            detail[props.header[idRow]["key"]]
                          ).toLocaleDateString("ID");
                        }
                        if (texts === "Invalid Date") {
                          texts = "";
                        }
                        switch (props.header[idRow]["modifiers"]) {
                          case "Izin":
                            if (texts === "1") {
                              texts = "Pulang Cepat";
                            } else if (texts === "2") {
                              texts = "Terlambat Datang";
                            } else if (texts === "3") {
                              texts = "Keluar Jam Kerja";
                            } else if (texts === "4") {
                              texts = "Tidak masuk kerja";
                            }
                            break;
                          case "JenisTiket":
                            if (texts === "1") {
                              texts = "Darat";
                            } else if (texts === "2") {
                              texts = "Laut";
                            } else if (texts === "3") {
                              texts = "Udara";
                            }
                            break;
                          case "DasarPermohonan":
                            if (texts === "1") {
                              texts = "Cuti";
                            } else if (texts === "2") {
                              texts = "Perjalanan Dinas";
                            } else if (texts === "3") {
                              texts = "Training";
                            }
                            break;
                          case "JenisRawat":
                            if (texts === "1") {
                              texts = "Rawat Jalan";
                            } else if (texts === "2") {
                              texts = "Rawat Inap";
                            } else if (texts === "3") {
                              texts = "Operasi";
                            }
                            break;
                          case "JenisKelamin":
                            if (texts === 1) {
                              texts = "Pria";
                            } else if (texts === 0) {
                              texts = "Wanita";
                            }
                            break;
                          case "Pendidikan":
                            if (texts === "1") {
                              texts = "SD";
                            } else if (texts === "2") {
                              texts = "SMP";
                            } else if (texts === "3") {
                              texts = "SMA / SMK";
                            } else if (texts === "4") {
                              texts = "D1";
                            } else if (texts === "5") {
                              texts = "D2";
                            } else if (texts === "6") {
                              texts = "D3";
                            } else if (texts === "7") {
                              texts = "S1";
                            } else if (texts === "8") {
                              texts = "S2";
                            } else if (texts === "9") {
                              texts = "S3";
                            }
                            break;
                          case "StatusPerkawinan":
                            if (texts === "1") {
                              texts = "Belum Menikah";
                            } else if (texts === "2") {
                              texts = "Menikah";
                            }
                            break;
                          case "WargaNegara":
                            if (texts === "1") {
                              texts = "Indonesia";
                            } else if (texts === "2") {
                              texts = "Asing";
                            }
                            break;
                          case "Agama":
                            if (texts === 1) {
                              texts = "Islam";
                            } else if (texts === 2) {
                              texts = "Protestan";
                            } else if (texts === 3) {
                              texts = "Katolik";
                            } else if (texts === 4) {
                              texts = "Hindu";
                            } else if (texts === 5) {
                              texts = "Buddha";
                            } else if (texts === 6) {
                              texts = "Khonghucu";
                            }
                            break;
                          case "SistemGaji":
                            if (texts === 1) {
                              texts = "Transfer";
                            } else if (texts === 2) {
                              texts = "Cash";
                            }
                            break;
                          case "Status":
                            if (texts === "1") {
                              texts = "Aktif";
                            } else if (texts === "2") {
                              texts = "Non-Active";
                            }
                            break;
                          case "Number":
                            texts = parseFloat(texts).toLocaleString("in-ID", {
                              maximumFractionDigits: 2,
                            });
                            break;
                          case "StatusPajak":
                            switch (texts) {
                              case "1":
                                texts = "TK0";
                                break;
                              case "2":
                                texts = "TK1";
                                break;
                              case "3":
                                texts = "TK2";
                                break;
                              case "4":
                                texts = "TK3";
                                break;
                              case "5":
                                texts = "K0";
                                break;
                              case "6":
                                texts = "K1";
                                break;
                              case "7":
                                texts = "K2";
                                break;
                              case "8":
                                texts = "K3";
                                break;
                            }
                        }
                        if (props.header[idRow]["name"] !== "Action") {
                          if (props.header[idRow]["modifiers"] === "LihatPR") {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Blanko", value: "3" },
                              // { label: "Hapus", value: "4" },
                            ];

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "4") {
                                    navigate(
                                      "/procurment/delete/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPC"
                          ) {
                            let LihatSelect = [
                              { label: "Price Comparison", value: "1" },
                              { label: "Hapus", value: "2" },
                            ];

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/delete/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPO"
                          ) {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Price Comparison", value: "2" },
                              { label: "Blanko", value: "3" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatPenerimaan"
                          ) {
                            let LihatSelect = [
                              { label: "Blanko PO", value: "1" },
                              { label: "Buat Penerimaan", value: "2" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/gudang/transaction/form-penerimaan-barang-add/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatKendaraan"
                          ) {
                            let LihatSelect = [{ label: "Detail", value: "1" }];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/equipment/kendaraan/preview/" +
                                        detail["TKendaraanID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          }
                        }
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      ) : (
        <div></div>
      )}
      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto text-wrap relative overflow-y-auto"}
            style={{ maxHeight: "600px" }}
          >
            <table className="text-sm text-left text-gray-500  mt-10  w-full">
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.data &&
                  props.data.data.map((detail, id) => {
                    var classOdd =
                      "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                    if (id % 2 === 0)
                      classOdd =
                        "bg-white border-b  hover:bg-gray-200 hover:text-main-100";

                    return (
                      <tr className={classOdd} key={"tabletr-" + id}>
                        {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          if (texts === "Invalid Date") {
                            texts = "";
                          }
                          switch (props.header[idRow]["modifiers"]) {
                            case "Izin":
                              if (texts === "1") {
                                texts = "Pulang Cepat";
                              } else if (texts === "2") {
                                texts = "Terlambat Datang";
                              } else if (texts === "3") {
                                texts = "Keluar Jam Kerja";
                              } else if (texts === "4") {
                                texts = "Tidak masuk kerja";
                              }
                              break;
                            case "JenisTiket":
                              if (texts === "1") {
                                texts = "Darat";
                              } else if (texts === "2") {
                                texts = "Laut";
                              } else if (texts === "3") {
                                texts = "Udara";
                              }
                              break;
                            case "DasarPermohonan":
                              if (texts === "1") {
                                texts = "Cuti";
                              } else if (texts === "2") {
                                texts = "Perjalanan Dinas";
                              } else if (texts === "3") {
                                texts = "Training";
                              }
                              break;
                            case "JenisRawat":
                              if (texts === "1") {
                                texts = "Rawat Jalan";
                              } else if (texts === "2") {
                                texts = "Rawat Inap";
                              } else if (texts === "3") {
                                texts = "Operasi";
                              }
                              break;
                            case "JenisKelamin":
                              if (texts === 1) {
                                texts = "Pria";
                              } else if (texts === 0) {
                                texts = "Wanita";
                              }
                              break;
                            case "Pendidikan":
                              if (texts === "1") {
                                texts = "SD";
                              } else if (texts === "2") {
                                texts = "SMP";
                              } else if (texts === "3") {
                                texts = "SMA / SMK";
                              } else if (texts === "4") {
                                texts = "D1";
                              } else if (texts === "5") {
                                texts = "D2";
                              } else if (texts === "6") {
                                texts = "D3";
                              } else if (texts === "7") {
                                texts = "S1";
                              } else if (texts === "8") {
                                texts = "S2";
                              } else if (texts === "9") {
                                texts = "S3";
                              }
                              break;
                            case "StatusPerkawinan":
                              if (texts === "1") {
                                texts = "Belum Menikah";
                              } else if (texts === "2") {
                                texts = "Menikah";
                              }
                              break;
                            case "WargaNegara":
                              if (texts === "1") {
                                texts = "Indonesia";
                              } else if (texts === "2") {
                                texts = "Asing";
                              }
                              break;
                            case "Agama":
                              if (texts === 1) {
                                texts = "Islam";
                              } else if (texts === 2) {
                                texts = "Protestan";
                              } else if (texts === 3) {
                                texts = "Katolik";
                              } else if (texts === 4) {
                                texts = "Hindu";
                              } else if (texts === 5) {
                                texts = "Buddha";
                              } else if (texts === 6) {
                                texts = "Khonghucu";
                              }
                              break;
                            case "SistemGaji":
                              if (texts === 1) {
                                texts = "Transfer";
                              } else if (texts === 2) {
                                texts = "Cash";
                              }
                              break;
                            case "Status":
                              if (texts === "1") {
                                texts = "Aktif";
                              } else if (texts === "2") {
                                texts = "Non-Active";
                              }
                              break;
                            case "Number":
                              texts = parseFloat(texts).toLocaleString(
                                "in-ID",
                                { maximumFractionDigits: 2 }
                              );
                              break;
                            case "StatusPajak":
                              switch (texts) {
                                case "1":
                                  texts = "TK0";
                                  break;
                                case "2":
                                  texts = "TK1";
                                  break;
                                case "3":
                                  texts = "TK2";
                                  break;
                                case "4":
                                  texts = "TK3";
                                  break;
                                case "5":
                                  texts = "K0";
                                  break;
                                case "6":
                                  texts = "K1";
                                  break;
                                case "7":
                                  texts = "K2";
                                  break;
                                case "8":
                                  texts = "K3";
                                  break;
                              }
                          }
                          if (props.header[idRow]["modifiers"] === "LihatPR") {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Blanko", value: "3" },
                              // { label: "Hapus", value: "4" },
                            ];

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "4") {
                                    navigate(
                                      "/procurment/delete/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPC"
                          ) {
                            let LihatSelect = [
                              { label: "Price Comparison", value: "1" },
                              { label: "Hapus", value: "2" },
                            ];

                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/delete/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "LihatPO"
                          ) {
                            let LihatSelect = [
                              { label: "Purchase Requisiton", value: "1" },
                              { label: "Price Comparison", value: "2" },
                              { label: "Blanko", value: "3" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/preview/purchase-requisition/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/procurment/preview/price-comparison/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["MPRComparisonID"].replaceAll(
                                          "/",
                                          "-"
                                        ) +
                                        "/" +
                                        detail[
                                          "PurchaseRequisitionID"
                                        ].replaceAll("/", "-")
                                    );
                                  } else if (text.value === "3") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatPenerimaan"
                          ) {
                            let LihatSelect = [
                              { label: "Blanko PO", value: "1" },
                              { label: "Buat Penerimaan", value: "2" },
                            ];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/procurment/blanco/po/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  } else if (text.value === "2") {
                                    navigate(
                                      "/gudang/transaction/form-penerimaan-barang-add/" +
                                        detail["BisnisUnitID"] +
                                        "/" +
                                        detail["PurchaseOrderID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else if (
                            props.header[idRow]["modifiers"] ===
                            "LihatKendaraan"
                          ) {
                            let LihatSelect = [{ label: "Detail", value: "1" }];
                            return (
                              <Select
                                className={
                                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                                }
                                onChange={(text) => {
                                  if (text.value === "1") {
                                    navigate(
                                      "/equipment/kendaraan/preview/" +
                                        detail["TKendaraanID"]
                                    );
                                  }
                                }}
                                options={LihatSelect}
                              />
                            );
                          } else {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          }
                        })}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableExtend(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);

  useEffect(() => {
    if (currentPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2);
      setPagingTwo(currentPage - 1);
      setPagingThree(currentPage);
      setPagingFour(currentPage + 1);
      setPagingFive(currentPage + 2);
    }
  }, [currentPage]);

  let many = 0;
  if (dataMajor) {
    many = dataMajor.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <DownloadTableExcel
                filename={"Report_" + props.name + "xlsx"}
                sheet="users"
                currentTableRef={tableRef.current}
              >
                <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                  {" "}
                  Download Excel {props.moduleName}
                </button>
              </DownloadTableExcel>
            )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmall
              text={"Cari " + props.name}
              funcs={props.menuController}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
        Show
        <div className="inline-block relative w-16 mx-1">
          <select
            value={currentCount}
            onChange={(e) => {
              setCurrentCount(e.target.value);
              setCurrentPage(1);
              props.updateCount(e.target.value);
            }}
            className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={-1}>All</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        Data
      </div>

      <CardBody className="w-full pt-0 ">
        {dataMajor ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataMajor.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          // Format kolom angka mengikuti Buku Besar: bilangan bulat
                          // dengan pemisah ribuan id-ID (mis. 9.071.229.331).
                          if (props.header[idRow]["modifiers"] === "Number ") {
                            texts = Math.round(
                              parseFloat(detail[props.header[idRow]["key"]] || 0)
                            ).toLocaleString("id-ID", { maximumFractionDigits: 0 });
                          }

                          switch (props.header[idRow]["modifiers"]) {
                            case "Izin":
                              if (texts === "1") {
                                texts = "Pulang Cepat";
                              } else if (texts === "2") {
                                texts = "Terlambat Datang";
                              } else if (texts === "3") {
                                texts = "Keluar Jam Kerja";
                              } else if (texts === "4") {
                                texts = "Tidak masuk kerja";
                              }
                              break;
                            case "JenisTiket":
                              if (texts === "1") {
                                texts = "Darat";
                              } else if (texts === "2") {
                                texts = "Laut";
                              } else if (texts === "3") {
                                texts = "Udara";
                              }
                              break;
                            case "DasarPermohonan":
                              if (texts === "1") {
                                texts = "Cuti";
                              } else if (texts === "2") {
                                texts = "Perjalanan Dinas";
                              } else if (texts === "3") {
                                texts = "Training";
                              }
                              break;
                            case "JenisRawat":
                              if (texts === "1") {
                                texts = "Rawat Jalan";
                              } else if (texts === "2") {
                                texts = "Rawat Inap";
                              } else if (texts === "3") {
                                texts = "Operasi";
                              }
                              break;
                            case "JenisKelamin":
                              if (texts === 1) {
                                texts = "Pria";
                              } else if (texts === 0) {
                                texts = "Wanita";
                              }
                              break;
                            case "Pendidikan":
                              if (texts === "1") {
                                texts = "SD";
                              } else if (texts === "2") {
                                texts = "SMP";
                              } else if (texts === "3") {
                                texts = "SMA / SMK";
                              } else if (texts === "4") {
                                texts = "D1";
                              } else if (texts === "5") {
                                texts = "D2";
                              } else if (texts === "6") {
                                texts = "D3";
                              } else if (texts === "7") {
                                texts = "S1";
                              } else if (texts === "8") {
                                texts = "S2";
                              } else if (texts === "9") {
                                texts = "S3";
                              }
                              break;
                            case "StatusPerkawinan":
                              if (texts === "1") {
                                texts = "Belum Menikah";
                              } else if (texts === "2") {
                                texts = "Menikah";
                              }
                              break;
                            case "WargaNegara":
                              if (texts === "1") {
                                texts = "Indonesia";
                              } else if (texts === "2") {
                                texts = "Asing";
                              }
                              break;
                            case "Agama":
                              if (texts === 1) {
                                texts = "Islam";
                              } else if (texts === 2) {
                                texts = "Protestan";
                              } else if (texts === 3) {
                                texts = "Katolik";
                              } else if (texts === 4) {
                                texts = "Hindu";
                              } else if (texts === 5) {
                                texts = "Buddha";
                              } else if (texts === 6) {
                                texts = "Khonghucu";
                              }
                              break;
                            case "SistemGaji":
                              if (texts === 1) {
                                texts = "Transfer";
                              } else if (texts === 2) {
                                texts = "Cash";
                              }
                              break;
                            case "Status":
                              if (texts === "1") {
                                texts = "Aktif";
                              } else if (texts === "2") {
                                texts = "Non-Active";
                              }
                              break;
                            case "StatusPajak":
                              switch (texts) {
                                case "1":
                                  texts = "TK0";
                                  break;
                                case "2":
                                  texts = "TK1";
                                  break;
                                case "3":
                                  texts = "TK2";
                                  break;
                                case "4":
                                  texts = "TK3";
                                  break;
                                case "5":
                                  texts = "K0";
                                  break;
                                case "6":
                                  texts = "K1";
                                  break;
                                case "7":
                                  texts = "K2";
                                  break;
                                case "8":
                                  texts = "K3";
                                  break;
                              }
                          }
                          if (props.header[idRow]["modifiers"] !== "Button") {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right "
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          } else {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                <a
                                  onClick={(e) => props.modal(detail)}
                                  className={
                                    "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                  }
                                >
                                  {data.name}
                                </a>
                              </th>
                            );
                          }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <nav
              className="flex justify-between items-center pt-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                Showing{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {currentPage === 1
                    ? currentPage
                    : (currentPage - 1) * props.count}
                  -
                  {currentPage * props.count > count
                    ? count
                    : currentPage * props.count}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {count}
                </span>
              </span>
              <ul className="inline-flex items-center -space-x-px">
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                        props.updatePage(currentPage - 1);
                      }
                    }}
                    className="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
                {props.maxPage > 0 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingOne);
                        props.updatePage(pagingOne);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingOne ? selected : notSelected
                      }`}
                    >
                      {pagingOne}
                    </a>
                  </li>
                )}
                {props.maxPage > 1 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingTwo);
                        props.updatePage(pagingTwo);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingTwo ? selected : notSelected
                      }`}
                    >
                      {pagingTwo}
                    </a>
                  </li>
                )}
                {props.maxPage > 2 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingThree);
                        props.updatePage(pagingThree);
                      }}
                      href="#"
                      aria-current="page"
                      className={`${
                        currentPage === pagingThree ? selected : notSelected
                      }`}
                    >
                      {pagingThree}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 3 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFour);
                        props.updatePage(pagingFour);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFour ? selected : notSelected
                      }`}
                    >
                      {pagingFour}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 4 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFive);
                        props.updatePage(pagingFive);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFive ? selected : notSelected
                      }`}
                    >
                      {pagingFive}
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => {
                      if (currentPage < props.maxPage) {
                        setCurrentPage(currentPage + 1);
                        props.updatePage(currentPage + 1);
                      }
                    }}
                    href="#"
                    className="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

// export function DynamicTableExtendStock(props) {
//   const tableRef = useRef(null);
//   const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
//   const selected =
//     "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
//   const notSelected =
//     "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
//   const breakpoint = 620;
//   let dataMajor = [];
//   let count = 0;
//   if (props.data) {
//     dataMajor = props.data.data;
//     count = props.data.count;
//   }
//   const width = React.useState(window.innerWidth);
//   const [pagingOne, setPagingOne] = React.useState(1);
//   const [pagingTwo, setPagingTwo] = React.useState(2);
//   const [pagingThree, setPagingThree] = React.useState(3);
//   const [pagingFour, setPagingFour] = React.useState(4);
//   const [pagingFive, setPagingFive] = React.useState(5);
//   const [currentPage, setCurrentPage] = React.useState(props.currentPage);
//   let headerNames = [];
//   let dataArray = [];

//   // ✅ Tambahkan KodeStockOpname di export header
//   props.header.map((data) => {
//     if (
//       data.name !== "Action" &&
//       (data.key == "Pengeluaraan" ||
//         data.key == "Penerimaan" ||
//         data.key == "SaldoAkhir" ||
//         data.key == "SaldoAwal" ||
//         data.key == "BarangID" ||
//         data.key == "NamaBarang" ||
//         data.key == "NamaSatuan" ||
//         data.key == "KodeStockOpname") // ✅ ditambahkan
//     ) {
//       headerNames.push(data.name);
//     }
//   });

//   props.data &&
//     props.data.data &&
//     props.data.data.map((detail, id) => {
//       let tempdata = [];
//       props.header.map((data, idRow) => {
//         if (data.name !== "Action") {
//           if (data.modifiers === "Date") {
//             tempdata.push(
//               new Date(detail[props.header[idRow]["key"]]).toDateString()
//             );
//           } else {
//             tempdata.push(detail[props.header[idRow]["key"]]);
//           }
//         }
//       });
//       dataArray.push(tempdata);
//     });

//   function handleDownloadExcel() {
//     let tempdata = [];
//     dataMajor &&
//       dataMajor.map((detail, id) => {
//         let tempdatadetail = {};
//         props.header.map((data, idRow) => {
//           if (
//             data.key == "Pengeluaraan" ||
//             data.key == "Penerimaan" ||
//             data.key == "SaldoAkhir" ||
//             data.key == "SaldoAwal" ||
//             data.key == "BarangID" ||
//             data.key == "NamaBarang" ||
//             data.key == "NamaSatuan" ||
//             data.key == "KodeStockOpname" // ✅ ditambahkan
//           ) {
//             let texts = detail[props.header[idRow]["key"]];
//             if (props.header[idRow]["modifiers"] === "Date") {
//               texts = new Date(
//                 detail[props.header[idRow]["key"]]
//               ).toLocaleDateString("ID");
//             }
//             let newObj = {};
//             newObj[props.header[idRow]["key"]] = texts;
//             tempdatadetail = { ...tempdatadetail, ...newObj };
//           }
//         });
//         tempdata.push(tempdatadetail);
//       });

//     downloadExcel({
//       fileName: "Report_" + props.title,
//       sheet: "data",
//       tablePayload: {
//         header: headerNames,
//         body: tempdata,
//       },
//     });
//   }

//   // ... (pagination useEffect tetap)

//   return (
//     <>
//       {/* Toolbar */}
//       {!props.withoutAttribut ? (
//         <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
//           <div className="flex flex-row">
//             {props.Master ? (
//               <button
//                 className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
//                 onClick={() => props.OnClick({})}
//               >
//                 Tambah +
//               </button>
//             ) : (
//               <button
//                 onClick={handleDownloadExcel}
//                 className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
//               >
//                 Download Excel
//               </button>
//             )}
//           </div>
//         </div>
//       ) : null}

//       {/* Table */}
//       <CardBody className="w-full pt-0 ">
//         <div className="overflow-x-auto relative overflow-y-auto">
//           <table
//             className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
//             ref={tableRef}
//           >
//             <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
//               <tr>
//                 <th scope="col" className="py-3 px-6" rowSpan={2}>
//                   Barang ID
//                 </th>
//                 {/* ✅ Tambahkan Kode Stock Opname */}
//                 <th scope="col" className="py-3 px-6" rowSpan={2}>
//                   Kode Stock Opname
//                 </th>
//                 <th scope="col" className="py-3 px-6" rowSpan={2}>
//                   Nama Barang
//                 </th>
//                 <th scope="col" className="py-3 px-6" rowSpan={2}>
//                   Satuan
//                 </th>
//                 <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
//                   Saldo Awal
//                 </th>
//                 <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
//                   Penerimaan
//                 </th>
//                 <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
//                   Tersedia
//                 </th>
//                 <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
//                   Pengeluaran
//                 </th>
//                 <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
//                   Saldo Akhir
//                 </th>
//               </tr>
//               <tr>
//                 <th className="py-3 px-6">Qty</th>
//                 <th className="py-3 px-6">Nominal</th>
//                 <th className="py-3 px-6">Qty</th>
//                 <th className="py-3 px-6">Nominal</th>
//                 <th className="py-3 px-6">Qty</th>
//                 <th className="py-3 px-6">Nominal</th>
//                 <th className="py-3 px-6">Qty</th>
//                 <th className="py-3 px-6">Nominal</th>
//                 <th className="py-3 px-6">Qty</th>
//                 <th className="py-3 px-6">Nominal</th>
//               </tr>
//             </thead>

//             <tbody>
//               {dataMajor?.map((detail, id) => {
//                 var classOdd =
//                   id % 2 === 0
//                     ? "bg-white border-b hover:bg-gray-200 hover:text-main-100"
//                     : "bg-gray-50 border-b hover:bg-gray-200 hover:text-main-100";

//                 return (
//                   <tr
//                     key={id}
//                     className={classOdd}
//                     onClick={() => !props.Master && props.OnClick(detail)}
//                   >
//                     {props.header.map((data, idRow) => {
//                       let texts = detail[props.header[idRow]["key"]];
//                       if (props.header[idRow]["modifiers"] === "Date") {
//                         texts = new Date(
//                           detail[props.header[idRow]["key"]]
//                         ).toLocaleDateString("ID");
//                       }

//                       let modifiers = props.header[idRow]["modifiers"];
//                       switch (modifiers) {
//                         case "Tersedia":
//                           texts =
//                             parseInt(detail["SaldoAwal"]) +
//                             parseInt(detail["Penerimaan"]);
//                           modifiers = "Number";
//                           break;
//                         // case "TersediaNominal":
//                         //   texts =
//                         //     parseInt(detail["SaldoAwalNominal"]) /
//                         //       parseInt(detail["SaldoAwal"] || 1) +
//                         //     parseInt(detail["PenerimaanNominal"]) /
//                         //       parseInt(detail["Penerimaan"] || 1);
//                         //   modifiers = "Number";
//                         //   break;
//                         // Di bagian kalkulasi TersediaNominal, perbaiki pembagian dengan 0
//                         case "TersediaNominal":
//                           const saldoAwalQty = parseInt(
//                             detail["SaldoAwal"] || 1
//                           );
//                           const penerimaanQty = parseInt(
//                             detail["Penerimaan"] || 1
//                           );

//                           const saldoAwalNominal = parseInt(
//                             detail["SaldoAwalNominal"] || 0
//                           );
//                           const penerimaanNominal = parseInt(
//                             detail["PenerimaanNominal"] || 0
//                           );

//                           texts =
//                             saldoAwalNominal / saldoAwalQty +
//                             penerimaanNominal / penerimaanQty;
//                           modifiers = "Number";
//                           break;
//                         case "Pengeluaraan":
//                           texts = parseInt(detail["Pengeluaraan"]) * -1;
//                           modifiers = "Number";
//                           break;
//                       }

//                       if (modifiers !== "Button") {
//                         return (
//                           <td
//                             key={"row" + id + "-" + idRow}
//                             className={
//                               "py-4 px-6 font-medium whitespace-nowrap " +
//                               (modifiers == "Number"
//                                 ? "text-right"
//                                 : "text-left")
//                             }
//                           >
//                             {modifiers === "Number"
//                               ? parseInt(texts || 0).toLocaleString()
//                               : texts}
//                           </td>
//                         );
//                       } else {
//                         return (
//                           <td
//                             key={"row" + id + "-" + idRow}
//                             className="py-4 px-6 font-medium whitespace-nowrap"
//                           >
//                             <a
//                               onClick={(e) => props.modal(detail)}
//                               className="border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
//                             >
//                               {data.name}
//                             </a>
//                           </td>
//                         );
//                       }
//                     })}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </CardBody>
//     </>
//   );
// }

export function DynamicTableExtendStock(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);
  let headerNames = [];
  let dataArray = [];

  // ✅ Tambahkan KodeStockOpname dan MinQty di export header
  props.header.map((data) => {
    if (
      data.name !== "Action" &&
      (data.key == "Pengeluaraan" ||
        data.key == "Penerimaan" ||
        data.key == "SaldoAkhir" ||
        data.key == "SaldoAwal" ||
        data.key == "BarangID" ||
        data.key == "NamaBarang" ||
        data.key == "NamaSatuan" ||
        data.key == "KodeStockOpname" ||
        data.key == "MinQty") // ✅ ditambahkan MinQty
    ) {
      headerNames.push(data.name);
    }
  });

  props.data &&
    props.data.data &&
    props.data.data.map((detail, id) => {
      let tempdata = [];
      props.header.map((data, idRow) => {
        if (data.name !== "Action") {
          if (data.modifiers === "Date") {
            tempdata.push(
              new Date(detail[props.header[idRow]["key"]]).toDateString()
            );
          } else {
            tempdata.push(detail[props.header[idRow]["key"]]);
          }
        }
      });
      dataArray.push(tempdata);
    });

  // Function untuk menentukan status stock
  const getStockStatus = (saldoAkhir, minQty) => {
    const saldoAkhirNum = parseFloat(saldoAkhir) || 0;
    const minQtyNum = parseFloat(minQty) || 0;
    const selisih = saldoAkhirNum - minQtyNum;

    if (selisih <= 0) {
      return {
        status: "danger",
        text: "Segerah PO",
        color: "text-red-600",
        bgColor: "bg-red-50",
        borderColor: "border-red-200",
      };
    } else {
      return {
        status: "safe",
        text: "Stock Tersedia",
        color: "text-green-600",
        bgColor: "bg-green-50",
        borderColor: "border-green-200",
      };
    }
  };

  function handleDownloadExcel() {
    let tempdata = [];
    dataMajor &&
      dataMajor.map((detail, id) => {
        let tempdatadetail = {};
        props.header.map((data, idRow) => {
          if (
            data.key == "Pengeluaraan" ||
            data.key == "Penerimaan" ||
            data.key == "SaldoAkhir" ||
            data.key == "SaldoAwal" ||
            data.key == "BarangID" ||
            data.key == "NamaBarang" ||
            data.key == "NamaSatuan" ||
            data.key == "KodeStockOpname" ||
            data.key == "MinQty" // ✅ ditambahkan MinQty
          ) {
            let texts = detail[props.header[idRow]["key"]];
            if (props.header[idRow]["modifiers"] === "Date") {
              texts = new Date(
                detail[props.header[idRow]["key"]]
              ).toLocaleDateString("ID");
            }
            let newObj = {};
            newObj[props.header[idRow]["key"]] = texts;
            tempdatadetail = { ...tempdatadetail, ...newObj };
          }
        });
        tempdata.push(tempdatadetail);
      });

    downloadExcel({
      fileName: "Report_" + props.title,
      sheet: "data",
      tablePayload: {
        header: headerNames,
        body: tempdata,
      },
    });
  }

  // ... (pagination useEffect tetap)

  return (
    <>
      {/* Toolbar */}
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <button
                onClick={handleDownloadExcel}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
              >
                Download Excel
              </button>
            )}
          </div>
        </div>
      ) : null}

      {/* Table */}
      <CardBody className="w-full pt-0 ">
        <div className="overflow-x-auto relative overflow-y-auto">
          <table
            className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
            ref={tableRef}
          >
            <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
              <tr>
                <th scope="col" className="py-3 px-6" rowSpan={2}>
                  Barang ID
                </th>
                <th scope="col" className="py-3 px-6" rowSpan={2}>
                  Kode Stock Opname
                </th>
                <th scope="col" className="py-3 px-6" rowSpan={2}>
                  Nama Barang
                </th>
                <th scope="col" className="py-3 px-6" rowSpan={2}>
                  Satuan
                </th>
                <th scope="col" className="py-3 px-6" rowSpan={2}>
                  Min Qty
                </th>
                <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
                  Saldo Awal
                </th>
                <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
                  Penerimaan
                </th>
                <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
                  Tersedia
                </th>
                <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
                  Pengeluaran
                </th>
                <th scope="col" className="py-3 px-6 text-center" colSpan={2}>
                  Saldo Akhir
                </th>
                <th scope="col" className="py-3 px-6" rowSpan={2}>
                  Status
                </th>
              </tr>
              <tr>
                <th className="py-3 px-6">Qty</th>
                <th className="py-3 px-6">Nominal</th>
                <th className="py-3 px-6">Qty</th>
                <th className="py-3 px-6">Nominal</th>
                <th className="py-3 px-6">Qty</th>
                <th className="py-3 px-6">Nominal</th>
                <th className="py-3 px-6">Qty</th>
                <th className="py-3 px-6">Nominal</th>
                <th className="py-3 px-6">Qty</th>
                <th className="py-3 px-6">Nominal</th>
              </tr>
            </thead>

            <tbody>
              {dataMajor?.map((detail, id) => {
                const stockStatus = getStockStatus(
                  detail.SaldoAkhir,
                  detail.MinQty
                );
                const selisih =
                  (parseFloat(detail.SaldoAkhir) || 0) -
                  (parseFloat(detail.MinQty) || 0);

                var classOdd =
                  id % 2 === 0
                    ? `bg-white border-b hover:bg-gray-200 hover:text-main-100 ${stockStatus.bgColor}`
                    : `bg-gray-50 border-b hover:bg-gray-200 hover:text-main-100 ${stockStatus.bgColor}`;

                return (
                  <tr
                    key={id}
                    className={`${classOdd} ${stockStatus.borderColor}`}
                    onClick={() => !props.Master && props.OnClick(detail)}
                  >
                    {props.header.map((data, idRow) => {
                      let texts = detail[props.header[idRow]["key"]];
                      if (props.header[idRow]["modifiers"] === "Date") {
                        texts = new Date(
                          detail[props.header[idRow]["key"]]
                        ).toLocaleDateString("ID");
                      }

                      let modifiers = props.header[idRow]["modifiers"];
                      switch (modifiers) {
                        case "Tersedia":
                          texts =
                            parseInt(detail["SaldoAwal"]) +
                            parseInt(detail["Penerimaan"]);
                          modifiers = "Number";
                          break;
                        case "TersediaNominal":
                          const saldoAwalNominal =
                            parseInt(detail["SaldoAwalNominal"]) || 0;
                          const penerimaanNominal =
                            parseInt(detail["PenerimaanNominal"]) || 0;
                          texts = saldoAwalNominal + penerimaanNominal;
                          modifiers = "Number";
                          break;
                        case "Pengeluaraan":
                          texts = (parseInt(detail["Pengeluaraan"]) || 0) * -1;
                          modifiers = "Number";
                          break;
                        case "PengeluaraanNominal":
                          texts =
                            (parseInt(detail["PengeluaraanNominal"]) || 0) * -1;
                          modifiers = "Number";
                          break;
                      }

                      // Apply red color for SaldoAkhir if stock is low
                      const isSaldoAkhir = data.key === "SaldoAkhir";
                      const textColorClass = isSaldoAkhir
                        ? stockStatus.color
                        : "";

                      if (modifiers !== "Button") {
                        return (
                          <td
                            key={"row" + id + "-" + idRow}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap " +
                              (modifiers == "Number"
                                ? "text-right"
                                : "text-left") +
                              " " +
                              textColorClass
                            }
                          >
                            {modifiers === "Number"
                              ? parseInt(texts || 0).toLocaleString()
                              : texts}
                          </td>
                        );
                      } else {
                        return (
                          <td
                            key={"row" + id + "-" + idRow}
                            className="py-4 px-6 font-medium whitespace-nowrap"
                          >
                            <a
                              onClick={(e) => props.modal(detail)}
                              className="border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
                            >
                              {data.name}
                            </a>
                          </td>
                        );
                      }
                    })}

                    {/* Status Column */}
                    <td
                      className={`py-4 px-6 font-medium whitespace-nowrap ${stockStatus.color}`}
                    >
                      <div className="flex items-center">
                        <span
                          className={`inline-block w-3 h-3 rounded-full mr-2 ${
                            stockStatus.status === "danger"
                              ? "bg-red-500"
                              : "bg-green-500"
                          }`}
                        ></span>
                        {stockStatus.text}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardBody>
    </>
  );
}

export function DynamicTableExtendAdjustStock(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);

  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;

  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Update paging
  useEffect(() => {
    if (props.maxPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(null);
      setPagingFive(null);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(null);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2 > 0 ? currentPage - 2 : 1);
      setPagingTwo(currentPage - 1 > 0 ? currentPage - 1 : 1);
      setPagingThree(currentPage);
      setPagingFour(
        currentPage + 1 <= props.maxPage ? currentPage + 1 : props.maxPage
      );
      setPagingFive(
        currentPage + 2 <= props.maxPage ? currentPage + 2 : props.maxPage
      );
    }

    setCurrentPage(props.currentPage);
  }, [currentPage, props.maxPage, props.currentPage]);

  let many = dataMajor?.length || 0;
  let Yscroll = many > 20 ? "h-screen" : "";

  // Excel export function
  function handleDownloadExcel() {
    let tempdata = [];
    dataMajor?.forEach((detail) => {
      let tempdatadetail = {};
      props.header.forEach((data) => {
        if (data.key !== "Edit") {
          let texts = detail[data.key];
          if (data.modifiers === "Date") {
            texts = new Date(detail[data.key]).toLocaleDateString("ID");
          }
          let newObj = {};
          newObj[data.name] = texts;
          tempdatadetail = { ...tempdatadetail, ...newObj };
        }
      });
      tempdata.push(tempdatadetail);
    });

    const headerNames = props.header
      .filter((data) => data.key !== "Edit")
      .map((data) => data.name);

    downloadExcel({
      fileName: "Report_" + props.title,
      sheet: "data",
      tablePayload: {
        header: headerNames,
        body: tempdata.map((item) =>
          headerNames.map((header) => item[header] || "")
        ),
      },
    });
  }

  return (
    <>
      {/* Attribut */}
      {!props.withoutAttribut && (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <button
                onClick={handleDownloadExcel}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
              >
                Download Excel
              </button>
            )}
          </div>
          {/* <div className="flex flex-row w-96">
            <SearchBarSmallV2
              text={"Cari " + props.name}
              value={props.value}
              funcs={props.menuController}
            />
          </div> */}
        </div>
      )}

      {/* Table */}
      <CardBody className="w-full pt-0">
        <div className={"overflow-x-auto relative overflow-y-auto " + Yscroll}>
          <table
            className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
            ref={tableRef}
          >
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="py-3 px-6" rowSpan={2}>
                  Barang ID
                </th>
                <th className="py-3 px-6" rowSpan={2}>
                  Kode Stock Opname
                </th>
                <th className="py-3 px-6" rowSpan={2}>
                  Nama Barang
                </th>
                <th className="py-3 px-6" rowSpan={2}>
                  Satuan
                </th>
                <th className="py-3 px-6 text-center" colSpan={2}>
                  Saldo Akhir
                </th>
                <th className="py-3 px-6 text-center" rowSpan={2}>
                  Action
                </th>
              </tr>
              <tr>
                <th className="py-3 px-6">Qty</th>
                <th className="py-3 px-6">Nominal</th>
              </tr>
            </thead>
            <tbody>
              {dataMajor?.map((detail, id) => {
                let classOdd =
                  id % 2 === 0
                    ? "bg-white border-b hover:bg-gray-200 hover:text-main-100"
                    : "bg-gray-50 border-b hover:bg-gray-200 hover:text-main-100";

                return (
                  <tr className={classOdd} key={`row-${id}`}>
                    {props.header.map((data, idRow) => {
                      if (data.key === "Edit") {
                        return (
                          <td
                            key={`btn-${id}-${idRow}`}
                            className="py-4 px-6 font-medium whitespace-nowrap text-center"
                          >
                            <button
                              onClick={() => props.OnClick(detail)}
                              className="border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
                            >
                              {data.name}
                            </button>
                          </td>
                        );
                      }

                      let texts = detail[data.key];
                      if (data.modifiers === "Date") {
                        texts = new Date(detail[data.key]).toLocaleDateString(
                          "ID"
                        );
                      }

                      let modifiers = data.modifiers;
                      switch (modifiers) {
                        case "SaldoAkhirNominal":
                          texts = parseInt(texts || 0).toLocaleString();
                          break;
                        case "number":
                          // parseFloat (bukan parseInt) + maximumFractionDigits: nilai
                          // pecahan (mis. Qty MSR 2.5) sebelumnya kepotong jadi "2" di
                          // sini walau tersimpan utuh di data — murni tampilan.
                          texts = parseFloat(texts || 0).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          });
                          break;
                        default:
                          texts = texts || "";
                      }

                      return (
                        <td
                          key={`cell-${id}-${idRow}`}
                          className={
                            "py-4 px-6 font-medium whitespace-nowrap " +
                            (data.modifiers === "number" ||
                            data.key === "SaldoAkhirNominal"
                              ? "text-right "
                              : "text-left ")
                          }
                        >
                          {texts}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
              {dataMajor?.length === 0 && (
                <tr>
                  <td
                    colSpan={props.header.length}
                    className="py-4 px-6 text-center"
                  >
                    Tidak ada data yang ditemukan
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {props.maxPage > 1 && (
          <div className="flex flex-col items-center py-4">
            <span className="text-sm text-gray-700 dark:text-gray-400">
              Menampilkan{" "}
              <span className="font-semibold">{dataMajor?.length}</span> dari{" "}
              <span className="font-semibold">{count}</span> entri
            </span>

            <div className="inline-flex mt-2 xs:mt-0">
              <button
                onClick={() =>
                  props.updatePage(currentPage > 1 ? currentPage - 1 : 1)
                }
                disabled={currentPage === 1}
                className="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-main-100 rounded-l hover:bg-main-200 disabled:opacity-50"
              >
                Sebelumnya
              </button>
              <button
                onClick={() =>
                  props.updatePage(
                    currentPage < props.maxPage
                      ? currentPage + 1
                      : props.maxPage
                  )
                }
                disabled={currentPage === props.maxPage}
                className="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-main-100 border-0 border-l border-main-200 rounded-r hover:bg-main-200 disabled:opacity-50"
              >
                Selanjutnya
              </button>
            </div>
          </div>
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableSimple(props) {
  const tableRef = useRef(null);

  let many = 0;
  if (props.data) {
    many = props.data.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      key={"row-" + id}
                      className={classOdd}
                      onClick={() => {
                        props.OnClick(detail);
                      }}
                    >
                        {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          if (
                            props.header[idRow]["modifiers"] === "EditDelete"
                          ) {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                {!detail.noEdit && (
                                  <>
                                    <a
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        props.edit(detail, id);
                                      }}
                                      className={
                                        "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      Edit
                                    </a>
                                    <a
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        props.delete(id);
                                      }}
                                      className={
                                        "border text-white bg-red-700 hover:bg-white hover:border hover:border-red-700 hover:text-red-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      Delete
                                    </a>
                                  </>
                                )}
                              </th>
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "Edit"
                          ) {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                <a
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    props.edit(detail, id);
                                  }}
                                  className={
                                    "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                  }
                                >
                                  Edit
                                </a>
                              </th>
                            );
                          } else {
                            switch (props.header[idRow]["modifiers"]) {
                              case "Izin":
                                if (texts === "1") {
                                  texts = "Pulang Cepat";
                                } else if (texts === "2") {
                                  texts = "Terlambat Datang";
                                } else if (texts === "3") {
                                  texts = "Keluar Jam Kerja";
                                } else if (texts === "4") {
                                  texts = "Tidak masuk kerja";
                                }
                                break;
                              case "JenisTiket":
                                if (texts === "1") {
                                  texts = "Darat";
                                } else if (texts === "2") {
                                  texts = "Laut";
                                } else if (texts === "3") {
                                  texts = "Udara";
                                }
                                break;
                              case "DasarPermohonan":
                                if (texts === "1") {
                                  texts = "Cuti";
                                } else if (texts === "2") {
                                  texts = "Perjalanan Dinas";
                                } else if (texts === "3") {
                                  texts = "Training";
                                }
                                break;
                              case "JenisRawat":
                                if (texts === "1") {
                                  texts = "Rawat Jalan";
                                } else if (texts === "2") {
                                  texts = "Rawat Inap";
                                } else if (texts === "3") {
                                  texts = "Operasi";
                                }
                                break;
                              case "JenisKelamin":
                                if (texts === 1) {
                                  texts = "Pria";
                                } else if (texts === 0) {
                                  texts = "Wanita";
                                }
                                break;
                              case "Pendidikan":
                                if (texts === "1") {
                                  texts = "SD";
                                } else if (texts === "2") {
                                  texts = "SMP";
                                } else if (texts === "3") {
                                  texts = "SMA / SMK";
                                } else if (texts === "4") {
                                  texts = "D1";
                                } else if (texts === "5") {
                                  texts = "D2";
                                } else if (texts === "6") {
                                  texts = "D3";
                                } else if (texts === "7") {
                                  texts = "S1";
                                } else if (texts === "8") {
                                  texts = "S2";
                                } else if (texts === "9") {
                                  texts = "S3";
                                }
                                break;
                              case "StatusPerkawinan":
                                if (texts === "1") {
                                  texts = "Belum Menikah";
                                } else if (texts === "2") {
                                  texts = "Menikah";
                                }
                                break;
                              case "WargaNegara":
                                if (texts === "1") {
                                  texts = "Indonesia";
                                } else if (texts === "2") {
                                  texts = "Asing";
                                }
                                break;
                              case "Agama":
                                if (texts === 1) {
                                  texts = "Islam";
                                } else if (texts === 2) {
                                  texts = "Protestan";
                                } else if (texts === 3) {
                                  texts = "Katolik";
                                } else if (texts === 4) {
                                  texts = "Hindu";
                                } else if (texts === 5) {
                                  texts = "Buddha";
                                } else if (texts === 6) {
                                  texts = "Khonghucu";
                                }
                                break;
                              case "SistemGaji":
                                if (texts === 1) {
                                  texts = "Transfer";
                                } else if (texts === 2) {
                                  texts = "Cash";
                                }
                                break;
                              case "Status":
                                if (texts === "1") {
                                  texts = "Aktif";
                                } else if (texts === "2") {
                                  texts = "Non-Active";
                                }
                                break;
                              case "StatusPajak":
                                switch (texts) {
                                  case "1":
                                    texts = "TK0";
                                    break;
                                  case "2":
                                    texts = "TK1";
                                    break;
                                  case "3":
                                    texts = "TK2";
                                    break;
                                  case "4":
                                    texts = "TK3";
                                    break;
                                  case "5":
                                    texts = "K0";
                                    break;
                                  case "6":
                                    texts = "K1";
                                    break;
                                  case "7":
                                    texts = "K2";
                                    break;
                                  case "8":
                                    texts = "K3";
                                    break;
                                }
                              case "dateOnly":
                                texts = new Date(texts);
                                const year = texts.getFullYear();
                                const month = texts.getMonth() + 1; // Months are zero-indexed, so add 1 to get the actual month.
                                const day = texts.getDate();
                                texts = `${day}/${month}/${year}`;
                                break;
                              case "dateOnlyNew":
                                texts = new Date(texts).toDateString();
                                break;
                              case "timeonly":
                                const datecheck = new Date(texts);
                                const currentOffset =
                                  new Date().getTimezoneOffset();

                                if (
                                  datecheck.getTimezoneOffset() !==
                                  currentOffset
                                ) {
                                  const targetOffset = -854; // Replace with the target time zone offset in minutes'
                                  let date = new Date(texts);
                                  const currentOffset =
                                    date.getTimezoneOffset();
                                  const targetTime =
                                    date.getTime() -
                                    (currentOffset - targetOffset) * 60 * 1000;
                                  date = new Date(targetTime);

                                  let hours = date.getHours();
                                  let minutes = date.getMinutes();

                                  texts = `${hours
                                    .toString()
                                    .padStart(2, "0")}:${minutes
                                    .toString()
                                    .padStart(2, "0")}:00`;
                                } else {
                                  let date = new Date(texts);
                                  let hours = date.getHours();
                                  let minutes = date.getMinutes();

                                  texts = `${hours
                                    .toString()
                                    .padStart(2, "0")}:${minutes
                                    .toString()
                                    .padStart(2, "0")}:00`;
                                }

                                break;

                              case "Barang":
                                if (props.barang) {
                                  const val = props.barang.data.filter(
                                    ({ value }) => value === texts
                                  );

                                  if (val[0]) {
                                    texts = val[0]["label"];
                                  }
                                }
                                break;
                              // Qty + nama satuan barang pada baris yang sama,
                              // mis. "10 Pcs". Satuannya dicari lewat
                              // detail.BarangID (bukan nilai selnya sendiri,
                              // yang berisi angka), jadi kolom ini hanya cocok
                              // untuk tabel yang barisnya punya BarangID.
                              // Kalau master barang belum termuat, angkanya
                              // tetap tampil apa adanya tanpa satuan.
                              case "QtySatuan":
                                if (props.barang && detail["BarangID"]) {
                                  const satuan = props.barang.data.find(
                                    ({ value }) => value === detail["BarangID"]
                                  )?.NamaSatuan;

                                  if (satuan) {
                                    texts = `${texts ?? ""} ${satuan}`.trim();
                                  }
                                }
                                break;
                              case "Activity":
                                if (props.activity) {
                                  const val = props.activity.data.filter(
                                    ({ value }) => value === texts
                                  );

                                  if (val[0]) {
                                    texts = val[0]["label"];
                                  }
                                }
                                break;
                              case "AccountName":
                                if (props.account) {
                                  const val = props.account.data.filter(
                                    ({ value }) => value === texts
                                  );

                                  if (val[0]) {
                                    texts = val[0]["label"];
                                  }
                                }
                                break;

                              case "Numbers":
                                texts = parseFloat(texts).toLocaleString(
                                  "in-ID",
                                  { maximumFractionDigits: 0 }
                                );
                                break;
                              case "BarangSatuan":
                                if (props.barang) {
                                  const val = props.barang.data.filter(
                                    ({ value }) => value === texts
                                  );
                                  if (val[0]) {
                                    texts = val[0]["NamaSatuan"];
                                  }
                                }
                                break;
                              case "QtyMasukBelum":
                                const val = detail["Qty"] - detail["QtyMasuk"];
                                texts = !isNaN(val) ? val : detail["Qty"];
                                break;
                              case "QtyBelumColor":
                                // Nilai sisa belum diterima (dari backend, kumulatif).
                                // <= 0 => sudah selesai diterima.
                                texts = parseFloat(texts || 0).toLocaleString(
                                  "in-ID",
                                  { maximumFractionDigits: 0 }
                                );
                                break;
                            }
                            let textColorClass = "text-black";
                            if (props.header[idRow]["modifiers"] === "Status") {
                              textColorClass = "text-main-100";
                            } else if (
                              props.header[idRow]["modifiers"] === "QtyBelumColor"
                            ) {
                              // Hijau jika sudah selesai (sisa <= 0), merah jika masih ada sisa.
                              const sisa = parseFloat(detail["QtyBelum"]);
                              textColorClass =
                                !isNaN(sisa) && sisa <= 0
                                  ? "text-green-600 font-bold"
                                  : "text-red-600 font-bold";
                            }
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  textColorClass
                                }
                              >
                                {texts}
                              </th>
                            );
                          }
                        })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableSimpleJurnal(props) {
  const tableRef = useRef(null);

  let many = 0;
  if (props.data) {
    many = props.data.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  let jumlahD = 0;
  let jumlahK = 0;
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      key={"row-" + id}
                      className={classOdd}
                      onClick={() => {
                        props.OnClick(detail);
                      }}
                    >
                        {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          if (
                            props.header[idRow]["modifiers"] === "EditDelete"
                          ) {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                {!detail.noEdit && (
                                  <>
                                    <a
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        props.edit(detail, id);
                                      }}
                                      className={
                                        "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      Edit
                                    </a>
                                    <a
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        props.delete(id);
                                      }}
                                      className={
                                        "border text-white bg-red-700 hover:bg-white hover:border hover:border-red-700 hover:text-red-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      Delete
                                    </a>
                                  </>
                                )}
                              </th>
                            );
                          } else if (
                            props.header[idRow]["modifiers"] === "Edit"
                          ) {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                <a
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    props.edit(detail, id);
                                  }}
                                  className={
                                    "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                  }
                                >
                                  Edit
                                </a>
                              </th>
                            );
                          } else {
                            if (props.header[idRow]["name"] === "Debet") {
                              jumlahD = parseFloat(jumlahD) + parseFloat(texts);
                            }
                            if (props.header[idRow]["name"] === "Kredit") {
                              jumlahK = parseFloat(jumlahK) + parseFloat(texts);
                            }
                            switch (props.header[idRow]["modifiers"]) {
                              case "Izin":
                                if (texts === "1") {
                                  texts = "Pulang Cepat";
                                } else if (texts === "2") {
                                  texts = "Terlambat Datang";
                                } else if (texts === "3") {
                                  texts = "Keluar Jam Kerja";
                                } else if (texts === "4") {
                                  texts = "Tidak masuk kerja";
                                }
                                break;
                              case "JenisTiket":
                                if (texts === "1") {
                                  texts = "Darat";
                                } else if (texts === "2") {
                                  texts = "Laut";
                                } else if (texts === "3") {
                                  texts = "Udara";
                                }
                                break;
                              case "DasarPermohonan":
                                if (texts === "1") {
                                  texts = "Cuti";
                                } else if (texts === "2") {
                                  texts = "Perjalanan Dinas";
                                } else if (texts === "3") {
                                  texts = "Training";
                                }
                                break;
                              case "JenisRawat":
                                if (texts === "1") {
                                  texts = "Rawat Jalan";
                                } else if (texts === "2") {
                                  texts = "Rawat Inap";
                                } else if (texts === "3") {
                                  texts = "Operasi";
                                }
                                break;
                              case "JenisKelamin":
                                if (texts === 1) {
                                  texts = "Pria";
                                } else if (texts === 0) {
                                  texts = "Wanita";
                                }
                                break;
                              case "Pendidikan":
                                if (texts === "1") {
                                  texts = "SD";
                                } else if (texts === "2") {
                                  texts = "SMP";
                                } else if (texts === "3") {
                                  texts = "SMA / SMK";
                                } else if (texts === "4") {
                                  texts = "D1";
                                } else if (texts === "5") {
                                  texts = "D2";
                                } else if (texts === "6") {
                                  texts = "D3";
                                } else if (texts === "7") {
                                  texts = "S1";
                                } else if (texts === "8") {
                                  texts = "S2";
                                } else if (texts === "9") {
                                  texts = "S3";
                                }
                                break;
                              case "StatusPerkawinan":
                                if (texts === "1") {
                                  texts = "Belum Menikah";
                                } else if (texts === "2") {
                                  texts = "Menikah";
                                }
                                break;
                              case "WargaNegara":
                                if (texts === "1") {
                                  texts = "Indonesia";
                                } else if (texts === "2") {
                                  texts = "Asing";
                                }
                                break;
                              case "Agama":
                                if (texts === 1) {
                                  texts = "Islam";
                                } else if (texts === 2) {
                                  texts = "Protestan";
                                } else if (texts === 3) {
                                  texts = "Katolik";
                                } else if (texts === 4) {
                                  texts = "Hindu";
                                } else if (texts === 5) {
                                  texts = "Buddha";
                                } else if (texts === 6) {
                                  texts = "Khonghucu";
                                }
                                break;
                              case "SistemGaji":
                                if (texts === 1) {
                                  texts = "Transfer";
                                } else if (texts === 2) {
                                  texts = "Cash";
                                }
                                break;
                              case "Status":
                                if (texts === "1") {
                                  texts = "Aktif";
                                } else if (texts === "2") {
                                  texts = "Non-Active";
                                }
                                break;
                              case "StatusPajak":
                                switch (texts) {
                                  case "1":
                                    texts = "TK0";
                                    break;
                                  case "2":
                                    texts = "TK1";
                                    break;
                                  case "3":
                                    texts = "TK2";
                                    break;
                                  case "4":
                                    texts = "TK3";
                                    break;
                                  case "5":
                                    texts = "K0";
                                    break;
                                  case "6":
                                    texts = "K1";
                                    break;
                                  case "7":
                                    texts = "K2";
                                    break;
                                  case "8":
                                    texts = "K3";
                                    break;
                                }
                              case "dateOnly":
                                texts = texts.toString();
                                break;
                              case "dateOnlyNew":
                                texts = new Date(texts).toDateString();
                                break;
                              case "Barang":
                                if (props.barang) {
                                  const val = props.barang.data.filter(
                                    ({ value }) => value === texts
                                  );

                                  if (val[0]) {
                                    texts = val[0]["label"];
                                  }
                                }
                                break;
                              case "AccountName":
                                if (props.account) {
                                  const val = props.account.data.filter(
                                    ({ value }) => value === texts
                                  );

                                  if (val[0]) {
                                    texts = val[0]["label"];
                                  }
                                }
                                break;

                              case "Numbers":
                                texts = parseFloat(texts).toLocaleString(
                                  "in-ID",
                                  { maximumFractionDigits: 0 }
                                );
                                break;
                              case "BarangSatuan":
                                if (props.barang) {
                                  const val = props.barang.data.filter(
                                    ({ value }) => value === texts
                                  );
                                  if (val[0]) {
                                    texts = val[0]["NamaSatuan"];
                                  }
                                }
                                break;
                            }

                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Numbers"
                                    ? "text-right "
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          }
                        })}
                    </tr>
                  );
                })}
                <tr
                  className={
                    "bg-gray-200 border-b  hover:bg-gray-200 hover:text-main-100 text-right"
                  }
                >
                  <th
                    scope="row"
                    colSpan={3}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-black text-main-100"
                    }
                  >
                    Jumlah
                  </th>
                  <th
                    scope="row"
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-black text-main-100"
                    }
                  >
                    {parseFloat(jumlahD).toLocaleString("in-ID", {
                      maximumFractionDigits: 0,
                    })}
                  </th>
                  <th
                    scope="row"
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-black text-main-100"
                    }
                  >
                    {parseFloat(jumlahK).toLocaleString("in-ID", {
                      maximumFractionDigits: 0,
                    })}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableExtendProcurment(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);

  useEffect(() => {
    if (currentPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2);
      setPagingTwo(currentPage - 1);
      setPagingThree(currentPage);
      setPagingFour(currentPage + 1);
      setPagingFive(currentPage + 2);
    }
  }, [currentPage]);

  let many = 0;
  if (dataMajor) {
    many = dataMajor.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master &&
              (props.types !== "PC" ||
                props.types !== "gudang" ||
                props.types !== "penerimaan-barang") && (
                <button
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                  onClick={() => props.OnClick({})}
                >
                  Tambah +
                </button>
              )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmall
              text={"Cari " + props.name}
              funcs={props.menuController}
              value={props.value}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
        Show
        <div className="inline-block relative w-16 mx-1">
          <select
            value={currentCount}
            onChange={(e) => {
              setCurrentCount(e.target.value);
              setCurrentPage(1);
              props.updateCount(e.target.value);
            }}
            className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={-1}>All</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        Data
      </div>

      <CardBody className="w-full pt-0 ">
        {dataMajor ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataMajor.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          // Format kolom angka mengikuti Buku Besar: bilangan bulat
                          // dengan pemisah ribuan id-ID (mis. 9.071.229.331).
                          if (props.header[idRow]["modifiers"] === "Number ") {
                            texts = Math.round(
                              parseFloat(detail[props.header[idRow]["key"]] || 0)
                            ).toLocaleString("id-ID", { maximumFractionDigits: 0 });
                          }

                          switch (props.header[idRow]["modifiers"]) {
                            case "Izin":
                              if (texts === "1") {
                                texts = "Pulang Cepat";
                              } else if (texts === "2") {
                                texts = "Terlambat Datang";
                              } else if (texts === "3") {
                                texts = "Keluar Jam Kerja";
                              } else if (texts === "4") {
                                texts = "Tidak masuk kerja";
                              }
                              break;
                            case "JenisTiket":
                              if (texts === "1") {
                                texts = "Darat";
                              } else if (texts === "2") {
                                texts = "Laut";
                              } else if (texts === "3") {
                                texts = "Udara";
                              }
                              break;
                            case "DasarPermohonan":
                              if (texts === "1") {
                                texts = "Cuti";
                              } else if (texts === "2") {
                                texts = "Perjalanan Dinas";
                              } else if (texts === "3") {
                                texts = "Training";
                              }
                              break;
                            case "JenisRawat":
                              if (texts === "1") {
                                texts = "Rawat Jalan";
                              } else if (texts === "2") {
                                texts = "Rawat Inap";
                              } else if (texts === "3") {
                                texts = "Operasi";
                              }
                              break;
                            case "JenisKelamin":
                              if (texts === 1) {
                                texts = "Pria";
                              } else if (texts === 0) {
                                texts = "Wanita";
                              }
                              break;
                            case "Pendidikan":
                              if (texts === "1") {
                                texts = "SD";
                              } else if (texts === "2") {
                                texts = "SMP";
                              } else if (texts === "3") {
                                texts = "SMA / SMK";
                              } else if (texts === "4") {
                                texts = "D1";
                              } else if (texts === "5") {
                                texts = "D2";
                              } else if (texts === "6") {
                                texts = "D3";
                              } else if (texts === "7") {
                                texts = "S1";
                              } else if (texts === "8") {
                                texts = "S2";
                              } else if (texts === "9") {
                                texts = "S3";
                              }
                              break;
                            case "StatusPerkawinan":
                              if (texts === "1") {
                                texts = "Belum Menikah";
                              } else if (texts === "2") {
                                texts = "Menikah";
                              }
                              break;
                            case "WargaNegara":
                              if (texts === "1") {
                                texts = "Indonesia";
                              } else if (texts === "2") {
                                texts = "Asing";
                              }
                              break;
                            case "Agama":
                              if (texts === 1) {
                                texts = "Islam";
                              } else if (texts === 2) {
                                texts = "Protestan";
                              } else if (texts === 3) {
                                texts = "Katolik";
                              } else if (texts === 4) {
                                texts = "Hindu";
                              } else if (texts === 5) {
                                texts = "Buddha";
                              } else if (texts === 6) {
                                texts = "Khonghucu";
                              }
                              break;
                            case "SistemGaji":
                              if (texts === 1) {
                                texts = "Transfer";
                              } else if (texts === 2) {
                                texts = "Cash";
                              }
                              break;
                            case "Status":
                              if (texts === "1") {
                                texts = "Aktif";
                              } else if (texts === "2") {
                                texts = "Non-Active";
                              }
                              break;
                            case "StatusPajak":
                              switch (texts) {
                                case "1":
                                  texts = "TK0";
                                  break;
                                case "2":
                                  texts = "TK1";
                                  break;
                                case "3":
                                  texts = "TK2";
                                  break;
                                case "4":
                                  texts = "TK3";
                                  break;
                                case "5":
                                  texts = "K0";
                                  break;
                                case "6":
                                  texts = "K1";
                                  break;
                                case "7":
                                  texts = "K2";
                                  break;
                                case "8":
                                  texts = "K3";
                                  break;
                              }
                          }
                          if (props.header[idRow]["modifiers"] !== "Button") {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          } else {
                            if (detail["STATUS"] !== "Waiting Approval") {
                              if (detail["STATUS"] !== "Menunggu Approval")
                                if (props.types === "PR") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap " +
                                        (props.header[idRow]["modifiers"] ===
                                        "Number "
                                          ? "text-right"
                                          : "text-left ") +
                                        (props.header[idRow]["modifiers"] !==
                                        "Status"
                                          ? "text-black"
                                          : "text-main-100")
                                      }
                                    >
                                      <a
                                        onClick={(e) => {
                                          props.editor(
                                            detail["PurchaseRequisitionID"]
                                          );
                                        }}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {data.name}
                                      </a>
                                      `
                                      <a
                                        onClick={(e) =>
                                          props.modal(
                                            detail["PurchaseRequisitionID"]
                                          )
                                        }
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {props.loadingButton ? (
                                          <>
                                            <svg
                                              aria-hidden="true"
                                              role="status"
                                              className="inline mr-3 w-4 h-4 text-white animate-spin"
                                              viewBox="0 0 100 101"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="#E5E7EB"
                                              />
                                              <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="current
                                       Color"
                                              />
                                            </svg>
                                            Loading
                                          </>
                                        ) : (
                                          "Kirim"
                                        )}
                                      </a>
                                    </th>
                                  );
                                } else if (props.types === "PC") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["STATUS"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail["PRComparisonID"],
                                                detail["BisnisUnitID"],
                                                detail["PurchaseRequisitionID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {detail["STATUS"] ===
                                            "Waiting Price Comparation"
                                              ? "Tambah"
                                              : "Edit"}
                                          </a>
                                          {detail["STATUS"] !==
                                            "Waiting Price Comparation" && (
                                            <a
                                              onClick={(e) => {
                                                props.kirim(
                                                  detail["PRComparisonID"],
                                                  detail[
                                                    "PurchaseRequisitionID"
                                                  ]
                                                );
                                              }}
                                              className={
                                                "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                              }
                                            >
                                              {"Kirim"}
                                            </a>
                                          )}
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "gudang") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["STATUS"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              props.kirim(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (
                                  props.types === "penerimaan-barang"
                                ) {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail[
                                                  "GoodsAcceptanceID"
                                                ].replaceAll("/", "-")
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              props.kirim(
                                                detail[
                                                  "GoodsAcceptanceID"
                                                ].replaceAll("/", "-")
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "kendaraan") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          {/* PERBAIKAN: Kirim detail object dan index, bukan string */}
                                          <a
                                            onClick={(e) => {
                                              e.stopPropagation(); // Mencegah event bubbling
                                              console.log(
                                                "Edit button clicked with:",
                                                { detail, id }
                                              );
                                              props.editor(detail, id); // Kirim detail object dan index
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none cursor-pointer"
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              e.stopPropagation(); // Mencegah event bubbling
                                              console.log(
                                                "Kirim button clicked with:",
                                                detail
                                              );
                                              props.kirim(detail); // Kirim detail object
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none cursor-pointer"
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (
                                  props.types === "pengeluaran-barang"
                                ) {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail[
                                                  "GoodsExpenditureID"
                                                ].replaceAll("/", "-"),
                                                detail["BisnisUnitID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              props.kirim(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "return-barang") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={() => {
                                              props.editor(
                                                detail["GoodsReturnID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={() => {
                                              props.kirim(
                                                detail["GoodsReturnID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (
                                  props.types === "penerimaan-barang-user"
                                ) {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={() => {
                                              props.editor(
                                                detail["GoodsAcceptanceUserID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={() => {
                                              props.kirim(
                                                detail["GoodsAcceptanceUserID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "Allocation") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => {
                                          props.editor(
                                            detail["PurchaseRequisitionID"]
                                          );
                                        }}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {"Set Allocation"}
                                      </a>
                                    </th>
                                  );
                                } else if (props.types === "PurchaseOrder") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => {
                                          props.editor(
                                            detail["PRComparisonID"],
                                            detail["PurchaseRequisitionID"]
                                          );
                                        }}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {"Make Purchase Order"}
                                      </a>
                                    </th>
                                  );
                                } else
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => props.modal(detail)}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {data.name}
                                      </a>
                                    </th>
                                  );
                            } else if (props.types === "PC") {
                              return (
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idRow}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                ></th>
                              );
                            } else {
                              return (
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idRow}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                ></th>
                              );
                            }
                          }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <nav
              className="flex justify-between items-center pt-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                Showing{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {currentPage === 1
                    ? currentPage
                    : (currentPage - 1) * props.count}
                  -
                  {currentPage * props.count > count
                    ? count
                    : currentPage * props.count}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {count}
                </span>
              </span>
              <ul className="inline-flex items-center -space-x-px">
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                        props.updatePage(currentPage - 1);
                      }
                    }}
                    className="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
                {props.maxPage > 0 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingOne);
                        props.updatePage(pagingOne);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingOne ? selected : notSelected
                      }`}
                    >
                      {pagingOne}
                    </a>
                  </li>
                )}
                {props.maxPage > 1 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingTwo);
                        props.updatePage(pagingTwo);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingTwo ? selected : notSelected
                      }`}
                    >
                      {pagingTwo}
                    </a>
                  </li>
                )}
                {props.maxPage > 2 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingThree);
                        props.updatePage(pagingThree);
                      }}
                      href="#"
                      aria-current="page"
                      className={`${
                        currentPage === pagingThree ? selected : notSelected
                      }`}
                    >
                      {pagingThree}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 3 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFour);
                        props.updatePage(pagingFour);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFour ? selected : notSelected
                      }`}
                    >
                      {pagingFour}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 4 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFive);
                        props.updatePage(pagingFive);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFive ? selected : notSelected
                      }`}
                    >
                      {pagingFive}
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => {
                      if (currentPage < props.maxPage) {
                        setCurrentPage(currentPage + 1);
                        props.updatePage(currentPage + 1);
                      }
                    }}
                    href="#"
                    className="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableExtendProcurmentWorkingSearch(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);

  useEffect(() => {
    if (currentPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2);
      setPagingTwo(currentPage - 1);
      setPagingThree(currentPage);
      setPagingFour(currentPage + 1);
      setPagingFive(currentPage + 2);
    }
  }, [currentPage]);

  let many = 0;
  if (dataMajor) {
    many = dataMajor.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
        Show
        <div className="inline-block relative w-16 mx-1">
          <select
            value={currentCount}
            onChange={(e) => {
              setCurrentCount(e.target.value);
              setCurrentPage(1);
              props.updateCount(e.target.value);
            }}
            className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={-1}>All</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        Data
      </div>

      <CardBody className="w-full pt-0 ">
        {dataMajor ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataMajor.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }
                          // Format kolom angka mengikuti Buku Besar: bilangan bulat
                          // dengan pemisah ribuan id-ID (mis. 9.071.229.331).
                          if (props.header[idRow]["modifiers"] === "Number ") {
                            texts = Math.round(
                              parseFloat(detail[props.header[idRow]["key"]] || 0)
                            ).toLocaleString("id-ID", { maximumFractionDigits: 0 });
                          }

                          switch (props.header[idRow]["modifiers"]) {
                            case "Izin":
                              if (texts === "1") {
                                texts = "Pulang Cepat";
                              } else if (texts === "2") {
                                texts = "Terlambat Datang";
                              } else if (texts === "3") {
                                texts = "Keluar Jam Kerja";
                              } else if (texts === "4") {
                                texts = "Tidak masuk kerja";
                              }
                              break;
                            case "JenisTiket":
                              if (texts === "1") {
                                texts = "Darat";
                              } else if (texts === "2") {
                                texts = "Laut";
                              } else if (texts === "3") {
                                texts = "Udara";
                              }
                              break;
                            case "DasarPermohonan":
                              if (texts === "1") {
                                texts = "Cuti";
                              } else if (texts === "2") {
                                texts = "Perjalanan Dinas";
                              } else if (texts === "3") {
                                texts = "Training";
                              }
                              break;
                            case "JenisRawat":
                              if (texts === "1") {
                                texts = "Rawat Jalan";
                              } else if (texts === "2") {
                                texts = "Rawat Inap";
                              } else if (texts === "3") {
                                texts = "Operasi";
                              }
                              break;
                            case "JenisKelamin":
                              if (texts === 1) {
                                texts = "Pria";
                              } else if (texts === 0) {
                                texts = "Wanita";
                              }
                              break;
                            case "Pendidikan":
                              if (texts === "1") {
                                texts = "SD";
                              } else if (texts === "2") {
                                texts = "SMP";
                              } else if (texts === "3") {
                                texts = "SMA / SMK";
                              } else if (texts === "4") {
                                texts = "D1";
                              } else if (texts === "5") {
                                texts = "D2";
                              } else if (texts === "6") {
                                texts = "D3";
                              } else if (texts === "7") {
                                texts = "S1";
                              } else if (texts === "8") {
                                texts = "S2";
                              } else if (texts === "9") {
                                texts = "S3";
                              }
                              break;
                            case "StatusPerkawinan":
                              if (texts === "1") {
                                texts = "Belum Menikah";
                              } else if (texts === "2") {
                                texts = "Menikah";
                              }
                              break;
                            case "WargaNegara":
                              if (texts === "1") {
                                texts = "Indonesia";
                              } else if (texts === "2") {
                                texts = "Asing";
                              }
                              break;
                            case "Agama":
                              if (texts === 1) {
                                texts = "Islam";
                              } else if (texts === 2) {
                                texts = "Protestan";
                              } else if (texts === 3) {
                                texts = "Katolik";
                              } else if (texts === 4) {
                                texts = "Hindu";
                              } else if (texts === 5) {
                                texts = "Buddha";
                              } else if (texts === 6) {
                                texts = "Khonghucu";
                              }
                              break;
                            case "SistemGaji":
                              if (texts === 1) {
                                texts = "Transfer";
                              } else if (texts === 2) {
                                texts = "Cash";
                              }
                              break;
                            case "Status":
                              if (texts === "1") {
                                texts = "Aktif";
                              } else if (texts === "2") {
                                texts = "Non-Aktif";
                              }
                              break;
                            case "StatusPajak":
                              switch (texts) {
                                case "1":
                                  texts = "TK0";
                                  break;
                                case "2":
                                  texts = "TK1";
                                  break;
                                case "3":
                                  texts = "TK2";
                                  break;
                                case "4":
                                  texts = "TK3";
                                  break;
                                case "5":
                                  texts = "K0";
                                  break;
                                case "6":
                                  texts = "K1";
                                  break;
                                case "7":
                                  texts = "K2";
                                  break;
                                case "8":
                                  texts = "K3";
                                  break;
                              }
                          }
                          if (props.header[idRow]["modifiers"] !== "Button") {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          } else {
                            if (detail["STATUS"] !== "Waiting Approval") {
                              if (detail["STATUS"] !== "Menunggu Approval")
                                if (props.types === "PR") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap " +
                                        (props.header[idRow]["modifiers"] ===
                                        "Number "
                                          ? "text-right"
                                          : "text-left ") +
                                        (props.header[idRow]["modifiers"] !==
                                        "Status"
                                          ? "text-black"
                                          : "text-main-100")
                                      }
                                    >
                                      <a
                                        onClick={(e) => {
                                          props.editor(
                                            detail["PurchaseRequisitionID"]
                                          );
                                        }}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {data.name}
                                      </a>
                                      `
                                      <a
                                        onClick={(e) =>
                                          props.modal(
                                            detail["PurchaseRequisitionID"]
                                          )
                                        }
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {props.loadingButton ? (
                                          <>
                                            <svg
                                              aria-hidden="true"
                                              role="status"
                                              className="inline mr-3 w-4 h-4 text-white animate-spin"
                                              viewBox="0 0 100 101"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="#E5E7EB"
                                              />
                                              <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="current
                                       Color"
                                              />
                                            </svg>
                                            Loading
                                          </>
                                        ) : (
                                          "Kirim"
                                        )}
                                      </a>
                                    </th>
                                  );
                                } else if (props.types === "PC") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["STATUS"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail["PRComparisonID"],
                                                detail["BisnisUnitID"],
                                                detail["PurchaseRequisitionID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {detail["STATUS"] ===
                                            "Waiting Price Comparation"
                                              ? "Tambah"
                                              : "Edit"}
                                          </a>
                                          {detail["STATUS"] !==
                                            "Waiting Price Comparation" && (
                                            <a
                                              onClick={(e) => {
                                                props.kirim(
                                                  detail["PRComparisonID"],
                                                  detail[
                                                    "PurchaseRequisitionID"
                                                  ]
                                                );
                                              }}
                                              className={
                                                "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                              }
                                            >
                                              {"Kirim"}
                                            </a>
                                          )}
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "gudang") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["STATUS"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              props.kirim(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (
                                  props.types === "penerimaan-barang"
                                ) {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail[
                                                  "GoodsAcceptanceID"
                                                ].replaceAll("/", "-")
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              props.kirim(
                                                detail[
                                                  "GoodsAcceptanceID"
                                                ].replaceAll("/", "-")
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (
                                  props.types === "pengeluaran-barang"
                                ) {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={(e) => {
                                              props.editor(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              props.kirim(
                                                detail["GoodsExpenditureID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "return-barang") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      {detail["Status"] !==
                                        "Menunggu Approval" && (
                                        <>
                                          <a
                                            onClick={() => {
                                              props.editor(
                                                detail["GoodsReturnID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            Edit
                                          </a>
                                          <a
                                            onClick={() => {
                                              props.kirim(
                                                detail["GoodsReturnID"]
                                              );
                                            }}
                                            className={
                                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                            }
                                          >
                                            {"Kirim"}
                                          </a>
                                        </>
                                      )}
                                    </th>
                                  );
                                } else if (props.types === "Allocation") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => {
                                          props.editor(
                                            detail["PurchaseRequisitionID"]
                                          );
                                        }}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {"Set Allocation"}
                                      </a>
                                    </th>
                                  );
                                } else if (props.types === "PurchaseOrder") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => {
                                          props.editor(
                                            detail["PRComparisonID"],
                                            detail["PurchaseRequisitionID"]
                                          );
                                        }}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {"Make Purchase Order"}
                                      </a>
                                    </th>
                                  );
                                } else if (props.types === "MasterBarang") {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => props.modal(detail)}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {"Edit"}
                                      </a>
                                      <a
                                        onClick={(e) => props.action(detail)}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {detail["Status"] == "1"
                                          ? "Non-Aktifkan"
                                          : "Aktifkan"}
                                      </a>
                                    </th>
                                  );
                                } else {
                                  return (
                                    <th
                                      scope="row"
                                      key={"row" + id + "-" + idRow}
                                      className={
                                        "py-4 px-6 font-medium whitespace-nowrap "
                                      }
                                    >
                                      <a
                                        onClick={(e) => props.modal(detail)}
                                        className={
                                          "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                        }
                                      >
                                        {data.name}
                                      </a>
                                    </th>
                                  );
                                }
                            } else if (props.types === "PC") {
                              return (
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idRow}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                ></th>
                              );
                            } else {
                              return (
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idRow}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                ></th>
                              );
                            }
                          }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <nav
              className="flex justify-between items-center pt-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                Showing{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {currentPage === 1
                    ? currentPage
                    : (currentPage - 1) * props.count}
                  -
                  {currentPage * props.count > count
                    ? count
                    : currentPage * props.count}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {count}
                </span>
              </span>
              <ul className="inline-flex items-center -space-x-px">
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                        props.updatePage(currentPage - 1);
                      }
                    }}
                    className="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
                {props.maxPage > 0 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingOne);
                        props.updatePage(pagingOne);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingOne ? selected : notSelected
                      }`}
                    >
                      {pagingOne}
                    </a>
                  </li>
                )}
                {props.maxPage > 1 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingTwo);
                        props.updatePage(pagingTwo);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingTwo ? selected : notSelected
                      }`}
                    >
                      {pagingTwo}
                    </a>
                  </li>
                )}
                {props.maxPage > 2 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingThree);
                        props.updatePage(pagingThree);
                      }}
                      href="#"
                      aria-current="page"
                      className={`${
                        currentPage === pagingThree ? selected : notSelected
                      }`}
                    >
                      {pagingThree}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 3 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFour);
                        props.updatePage(pagingFour);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFour ? selected : notSelected
                      }`}
                    >
                      {pagingFour}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 4 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFive);
                        props.updatePage(pagingFive);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFive ? selected : notSelected
                      }`}
                    >
                      {pagingFive}
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => {
                      if (currentPage < props.maxPage) {
                        setCurrentPage(currentPage + 1);
                        props.updatePage(currentPage + 1);
                      }
                    }}
                    href="#"
                    className="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableExtendFinance(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2);
      setPagingTwo(currentPage - 1);
      setPagingThree(currentPage);
      setPagingFour(currentPage + 1);
      setPagingFive(currentPage + 2);
    }
  }, [currentPage]);

  let many = 0;
  if (dataMajor) {
    many = dataMajor.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master &&
              (props.types !== "PC" ||
                props.types !== "gudang" ||
                props.types !== "penerimaan-barang") && (
                <button
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                  onClick={() => props.OnClick({})}
                >
                  Tambah +
                </button>
              )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmall
              text={"Cari " + props.name}
              funcs={props.menuController}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
        Show
        <div className="inline-block relative w-16 mx-1">
          <select
            value={currentCount}
            onChange={(e) => {
              setCurrentCount(e.target.value);
              setCurrentPage(1);
              props.updateCount(e.target.value);
            }}
            className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={-1}>All</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        Data
      </div>

      <CardBody className="w-full pt-0 ">
        {dataMajor ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataMajor.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      key={`row-${id}`}
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                          let texts = detail[props.header[idRow]["key"]];
                          if (props.header[idRow]["modifiers"] === "Date") {
                            texts = new Date(
                              detail[props.header[idRow]["key"]]
                            ).toLocaleDateString("ID");
                          }

                          if (props.header[idRow]["modifiers"] !== "Button") {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap " +
                                  (props.header[idRow]["modifiers"] ===
                                  "Number "
                                    ? "text-right"
                                    : "text-left ") +
                                  (props.header[idRow]["modifiers"] !== "Status"
                                    ? "text-black"
                                    : "text-main-100")
                                }
                              >
                                {texts}
                              </th>
                            );
                          } else {
                            return (
                              <th
                                scope="row"
                                key={"row" + id + "-" + idRow}
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                {detail["Status"] !== "Menunggu Approval" &&
                                  !(props.hideEditStatus || []).includes(
                                    detail["Status"]
                                  ) && (
                                  <>
                                    <a
                                      onClick={(e) => {
                                        props.editor(
                                          detail[props.primarykey]
                                            .toString()
                                            .replaceAll("/", "-")
                                        );
                                      }}
                                      className={
                                        "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      {"Edit"}
                                    </a>
                                  </>
                                )}

                                {props["cetakJurnal"] && (
                                  <>
                                    <a
                                      onClick={(e) =>
                                        navigate(
                                          "/accounting/jurnal/blanco/" +
                                            detail[props.primarykey]
                                        )
                                      }
                                      className={
                                        "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      {"Cetak Blanko"}
                                    </a>
                                  </>
                                )}

                                {/* Status apa saja yang boleh dikirim. Default tetap
                                    hanya "Menunggu Dikirim" agar 4 halaman lain yang
                                    memakai tabel ini tak berubah perilakunya; halaman
                                    yang punya alur revisi mengirim daftarnya sendiri
                                    (lihat kirimStatus di Pembayaran AP). */}
                                {(props.kirimStatus || ["Menunggu Dikirim"]).includes(
                                  detail["Status"]
                                ) && (
                                  <>
                                    <a
                                      onClick={(e) => {
                                        props.kirim(
                                          detail[props.primarykey]
                                            .toString()
                                            .replaceAll("/", "-")
                                        );
                                      }}
                                      className={
                                        "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                      }
                                    >
                                      {"Kirim"}
                                    </a>
                                  </>
                                )}
                              </th>
                            );
                          }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <nav
              className="flex justify-between items-center pt-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                Showing{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {currentPage === 1
                    ? currentPage
                    : (currentPage - 1) * props.count}
                  -
                  {currentPage * props.count > count
                    ? count
                    : currentPage * props.count}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {count}
                </span>
              </span>
              <ul className="inline-flex items-center -space-x-px">
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                        props.updatePage(currentPage - 1);
                      }
                    }}
                    className="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
                {props.maxPage > 0 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingOne);
                        props.updatePage(pagingOne);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingOne ? selected : notSelected
                      }`}
                    >
                      {pagingOne}
                    </a>
                  </li>
                )}
                {props.maxPage > 1 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingTwo);
                        props.updatePage(pagingTwo);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingTwo ? selected : notSelected
                      }`}
                    >
                      {pagingTwo}
                    </a>
                  </li>
                )}
                {props.maxPage > 2 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingThree);
                        props.updatePage(pagingThree);
                      }}
                      href="#"
                      aria-current="page"
                      className={`${
                        currentPage === pagingThree ? selected : notSelected
                      }`}
                    >
                      {pagingThree}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 3 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFour);
                        props.updatePage(pagingFour);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFour ? selected : notSelected
                      }`}
                    >
                      {pagingFour}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 4 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFive);
                        props.updatePage(pagingFive);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFive ? selected : notSelected
                      }`}
                    >
                      {pagingFive}
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => {
                      if (currentPage < props.maxPage) {
                        setCurrentPage(currentPage + 1);
                        props.updatePage(currentPage + 1);
                      }
                    }}
                    href="#"
                    className="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function JurnalTable(props) {
  const navigate = useNavigate();

  const tableRef = useRef(null);
  let GDebet = 0;
  let GCredit = 0;
  const dataList = props.data?.data || [];
  let Yscroll = "";
  if (dataList.length > 20) {
    Yscroll = "h-screen";
  }
  const level = props.level || "per-akun";
  const levelHeaders = {
    summary:  ["Tanggal", "No Jurnal", "Keterangan", "Debet", "Credit"],
    "per-akun": ["Tanggal", "No Jurnal", "No Akun", "Nama Akun", "Debet", "Credit"],
    detail:   ["Tanggal", "No Jurnal", "No Akun", "Nama Akun", "Keterangan", "Debet", "Credit"],
  };
  const activeHeaders = levelHeaders[level] || levelHeaders["per-akun"];
  const totalColSpan = activeHeaders.length - 2;

  const fmt = (n) => (parseFloat(n) || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 });

  function buildPdfRows() {
    const rows = [];
    let gDebet = 0;
    let gCredit = 0;
    const ncols = activeHeaders.length;

    (dataList || []).forEach((Transaksi) => {
      const tgl = new Date(Transaksi.Tanggal).toDateString();
      let tDebet = 0;
      let tCredit = 0;

      if (level === "summary") {
        const d = parseFloat(Transaksi.TotalDebet) || 0;
        const k = parseFloat(Transaksi.TotalKredit) || 0;
        rows.push([tgl, Transaksi.AccountingID, Transaksi.Keterangan, fmt(d), fmt(k)]);
        tDebet = d;
        tCredit = k;
      } else if (level === "per-akun") {
        const akunMap = {};
        (Transaksi.Data || []).forEach((d) => {
          if (!akunMap[d.NomorAccount]) akunMap[d.NomorAccount] = { NomorAccount: d.NomorAccount, NamaAccount: d.NamaAccount, Debet: 0, Kredit: 0 };
          akunMap[d.NomorAccount].Debet += parseFloat(d.Debet) || 0;
          akunMap[d.NomorAccount].Kredit += parseFloat(d.Kredit) || 0;
        });
        Object.values(akunMap).sort((a, b) => b.Debet - a.Debet).forEach((akun) => {
          rows.push([tgl, Transaksi.AccountingID, akun.NomorAccount, akun.NamaAccount, fmt(akun.Debet), fmt(akun.Kredit)]);
          tDebet += akun.Debet;
          tCredit += akun.Kredit;
        });
      } else {
        [...(Transaksi.Data || [])].sort((a, b) => (parseFloat(b.Debet) || 0) - (parseFloat(a.Debet) || 0)).forEach((d) => {
          const dd = parseFloat(d.Debet) || 0;
          const kk = parseFloat(d.Kredit) || 0;
          rows.push([tgl, Transaksi.AccountingID, d.NomorAccount, d.NamaAccount, d.Keterangan, fmt(dd), fmt(kk)]);
          tDebet += dd;
          tCredit += kk;
        });
      }

      // Total row per transaksi
      const totalRow = Array(ncols).fill("");
      totalRow[0] = "Total";
      totalRow[ncols - 2] = fmt(tDebet);
      totalRow[ncols - 1] = fmt(tCredit);
      rows.push(totalRow);

      gDebet += tDebet;
      gCredit += tCredit;
    });

    // Grand Total row
    const grandRow = Array(ncols).fill("");
    grandRow[0] = "Grand Total";
    grandRow[ncols - 2] = fmt(gDebet);
    grandRow[ncols - 1] = fmt(gCredit);
    rows.push(grandRow);

    return rows;
  }

  function buildExcelRows() {
    const rows = [];
    let gDebet = 0;
    let gCredit = 0;
    const ncols = activeHeaders.length;

    (dataList || []).forEach((Transaksi) => {
      const tgl = new Date(Transaksi.Tanggal).toDateString();
      let tDebet = 0;
      let tCredit = 0;

      if (level === "summary") {
        const d = parseFloat(Transaksi.TotalDebet) || 0;
        const k = parseFloat(Transaksi.TotalKredit) || 0;
        rows.push([tgl, Transaksi.AccountingID, Transaksi.Keterangan, d, k]);
        tDebet = d;
        tCredit = k;
      } else if (level === "per-akun") {
        const akunMap = {};
        (Transaksi.Data || []).forEach((d) => {
          if (!akunMap[d.NomorAccount]) akunMap[d.NomorAccount] = { NomorAccount: d.NomorAccount, NamaAccount: d.NamaAccount, Debet: 0, Kredit: 0 };
          akunMap[d.NomorAccount].Debet += parseFloat(d.Debet) || 0;
          akunMap[d.NomorAccount].Kredit += parseFloat(d.Kredit) || 0;
        });
        Object.values(akunMap).sort((a, b) => b.Debet - a.Debet).forEach((akun) => {
          rows.push([tgl, Transaksi.AccountingID, akun.NomorAccount, akun.NamaAccount, akun.Debet, akun.Kredit]);
          tDebet += akun.Debet;
          tCredit += akun.Kredit;
        });
      } else {
        [...(Transaksi.Data || [])].sort((a, b) => (parseFloat(b.Debet) || 0) - (parseFloat(a.Debet) || 0)).forEach((d) => {
          const dd = parseFloat(d.Debet) || 0;
          const kk = parseFloat(d.Kredit) || 0;
          rows.push([tgl, Transaksi.AccountingID, d.NomorAccount, d.NamaAccount, d.Keterangan, dd, kk]);
          tDebet += dd;
          tCredit += kk;
        });
      }

      const totalRow = Array(ncols).fill("");
      totalRow[0] = "Total";
      totalRow[ncols - 2] = tDebet;
      totalRow[ncols - 1] = tCredit;
      rows.push(totalRow);

      gDebet += tDebet;
      gCredit += tCredit;
    });

    const grandRow = Array(ncols).fill("");
    grandRow[0] = "Grand Total";
    grandRow[ncols - 2] = gDebet;
    grandRow[ncols - 1] = gCredit;
    rows.push(grandRow);

    return rows;
  }

  function handleDownloadExcel() {
    downloadExcel({
      fileName: "Report_Jurnal",
      sheet: "Jurnal",
      tablePayload: { header: activeHeaders, body: buildExcelRows() },
    });
  }

  function handleDownloadPDF() {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Report Jurnal", 14, 15);
    const pdfRows = buildPdfRows();
    autoTable(doc, {
      startY: 22,
      head: [activeHeaders],
      body: pdfRows,
      styles: { fontSize: 7 },
      headStyles: { fillColor: [41, 128, 185] },
      columnStyles: {
        [activeHeaders.length - 1]: { halign: "right" },
        [activeHeaders.length - 2]: { halign: "right" },
      },
      didParseCell: (data) => {
        if (data.section === "body") {
          const label = data.row.raw[0];
          if (label === "Grand Total") {
            data.cell.styles.fillColor = [147, 197, 253];
            data.cell.styles.fontStyle = "bold";
          } else if (label === "Total") {
            data.cell.styles.fillColor = [191, 219, 254];
            data.cell.styles.fontStyle = "bold";
          }
        }
      },
    });
    doc.save("Report_Jurnal.pdf");
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <div className="flex flex-row gap-2">
                <button
                  onClick={handleDownloadExcel}
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                >
                  Download Excel
                </button>
                <button
                  onClick={handleDownloadPDF}
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                >
                  Download PDF
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {activeHeaders.map((name, id) => (
                    <th scope="col" className={"py-3 px-6" + (name === "Debet" || name === "Credit" ? " text-right" : "")} key={"Header-" + name + id}>
                      {name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataList.map((Transaksi, id) => {
                    const fmt = (n) => (parseFloat(n) || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 });
                    const tgl = new Date(Transaksi.Tanggal).toDateString();

                    if (level === "summary") {
                      const Debet = parseFloat(Transaksi.TotalDebet) || 0;
                      const Kredit = parseFloat(Transaksi.TotalKredit) || 0;
                      GDebet += Debet;
                      GCredit += Kredit;
                      return (
                        <tr key={"jurnal-" + id} className="font-medium whitespace-nowrap">
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{tgl}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{Transaksi.AccountingID}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{Transaksi.Keterangan}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(Debet)}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(Kredit)}</th>
                        </tr>
                      );
                    }

                    let rows;
                    let Debet = 0;
                    let Kredit = 0;

                    if (level === "per-akun") {
                      const akunMap = {};
                      (Transaksi.Data || []).forEach((detail) => {
                        const key = detail.NomorAccount;
                        if (!akunMap[key]) {
                          akunMap[key] = { NomorAccount: key, NamaAccount: detail.NamaAccount, Debet: 0, Kredit: 0 };
                        }
                        akunMap[key].Debet += parseFloat(detail.Debet) || 0;
                        akunMap[key].Kredit += parseFloat(detail.Kredit) || 0;
                      });
                      const akunList = Object.values(akunMap).sort((a, b) => b.Debet - a.Debet);
                      Debet = akunList.reduce((s, a) => s + a.Debet, 0);
                      Kredit = akunList.reduce((s, a) => s + a.Kredit, 0);
                      rows = akunList.map((akun, i) => (
                        <tr key={"jurnal-" + id + "-" + i} className="font-medium whitespace-nowrap">
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{tgl}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{Transaksi.AccountingID}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{akun.NomorAccount}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{akun.NamaAccount}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(akun.Debet)}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(akun.Kredit)}</th>
                        </tr>
                      ));
                    } else {
                      (Transaksi.Data || []).forEach((d) => {
                        Debet += parseFloat(d.Debet) || 0;
                        Kredit += parseFloat(d.Kredit) || 0;
                      });
                      rows = [...(Transaksi.Data || [])].sort((a, b) => (parseFloat(b.Debet) || 0) - (parseFloat(a.Debet) || 0)).map((detail, i) => (
                        <tr key={"jurnal-" + id + "-" + i} className="font-medium whitespace-nowrap">
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{tgl}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{Transaksi.AccountingID}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{detail.NomorAccount}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{detail.NamaAccount}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap">{detail.Keterangan}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(detail.Debet)}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(detail.Kredit)}</th>
                        </tr>
                      ));
                    }

                    GDebet += Debet;
                    GCredit += Kredit;

                    return (
                      <React.Fragment key={"jurnal-" + id}>
                        {rows}
                        <tr className="font-medium whitespace-nowrap bg-blue-200">
                          <th scope="row" colSpan={totalColSpan} className="py-4 px-6 font-medium whitespace-nowrap">Total</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(Debet)}</th>
                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap text-right">{fmt(Kredit)}</th>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                <tr
                  className={
                    "py-4 px-6 font-medium whitespace-nowrap bg-blue-300 text-black"
                  }
                >
                  <th
                    scope="row"
                    key={"row"}
                    colSpan={totalColSpan}
                    className={"py-4 px-6 font-medium whitespace-nowrap"}
                  >
                    {"Grand Total"}
                  </th>
                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GDebet).toLocaleString("id-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GCredit).toLocaleString("id-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function BukuBesarTable(props) {
  const tableRef = useRef(null);

  // Rupiah tidak memakai pecahan; tampilkan sebagai bilangan bulat (kolom DB Debet/Kredit = bigint).
  const fmt = (val) =>
    Math.round(parseFloat(val || 0)).toLocaleString("id-ID", { maximumFractionDigits: 0 });

  const namaBulan = [
    "", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember",
  ];
  const periodeLabel =
    props.bulan && props.tahun
      ? `${namaBulan[parseInt(props.bulan, 10)] || props.bulan} ${props.tahun}`
      : "";

  const colHeader = ["Tanggal", "No Jurnal", "Keterangan", "Debet", "Kredit", "Saldo"];
  // Label saldo normal akun: 'K' => Kredit, selain itu Debit (samakan dgn Trial Balance).
  const normalLabel = (s) => (String(s).toUpperCase() === "K" ? "Kredit" : "Debit");
  // Rumus saldo SERAGAM untuk semua akun (permintaan user 2026-09-24):
  //   Saldo = Saldo sebelumnya + Debet − Kredit
  // Saldo Awal dipakai apa adanya dari backend (konvensi Debet−Kredit; seed AccountBalance
  // akun Kredit sudah dinegasikan di bukuBesarSaldoAwal). Akun bersaldo normal Kredit
  // (Hutang, Modal, Pendapatan) karenanya tampil NEGATIF bila bersaldo normal.
  const saldoAwalTampil = (akun) => parseFloat(akun.SaldoAwal || 0);

  // Akumulasi total mutasi periode (Debet & Kredit). Total Saldo lintas akun yang
  // berbeda jenis tidak bermakna secara akuntansi, jadi saldo grand total hanya
  // ditampilkan bila hasil berisi tepat satu akun.
  const akunRows = (props.data && props.data.data) || [];
  let GDebet = 0;
  let GKredit = 0;
  let GSaldoAkhir = 0;
  akunRows.forEach((akun) => {
    GDebet  += parseFloat(akun.TotalDebet  || 0);
    GKredit += parseFloat(akun.TotalKredit || 0);
  });
  const showGrandSaldo = akunRows.length === 1;
  if (showGrandSaldo) {
    const a0 = akunRows[0];
    GSaldoAkhir =
      saldoAwalTampil(a0) +
      (parseFloat(a0.TotalDebet || 0) - parseFloat(a0.TotalKredit || 0));
  }

  // Pagination level akun (server-side via start/count). totalCount = jumlah akun COA
  // yang cocok filter di backend.
  const pageSize = props.pageSize || maxPageGlobal;
  const totalCount = (props.data && props.data.count) || 0;
  const startIdx = props.start || 0;
  const currentPage = Math.floor(startIdx / pageSize) + 1;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const endIdx = Math.min(startIdx + pageSize, totalCount);

  const buildRows = () => {
    const rows = [];
    if (!props.data || !props.data.data) return rows;
    props.data.data.forEach((akun) => {
      rows.push({ type: "account", id: akun.DetailAccountID, nama: akun.DetailAccount, saldoNormal: normalLabel(akun.SaldoNormal), saldo: saldoAwalTampil(akun) });
      let runSaldo = saldoAwalTampil(akun);
      (akun.Data || []).forEach((d) => {
        runSaldo = runSaldo + (parseFloat(d.Debet || 0) - parseFloat(d.Kredit || 0));
        rows.push({ type: "detail", tanggal: new Date(d.Tanggal).toLocaleDateString("id-ID"), noJurnal: d.AccountingID, ket: d.Keterangan, debet: parseFloat(d.Debet || 0), kredit: parseFloat(d.Kredit || 0), saldo: runSaldo });
      });
      const saldoAkhir = saldoAwalTampil(akun) + (parseFloat(akun.TotalDebet || 0) - parseFloat(akun.TotalKredit || 0));
      rows.push({ type: "total", nama: akun.DetailAccount, debet: parseFloat(akun.TotalDebet || 0), kredit: parseFloat(akun.TotalKredit || 0), saldo: saldoAkhir });
    });
    rows.push({ type: "grandtotal", debet: GDebet, kredit: GKredit, saldo: showGrandSaldo ? GSaldoAkhir : null });
    return rows;
  };

  const handleDownloadExcel = () => {
    const rows = buildRows();
    const body = rows.map((r) => {
      if (r.type === "account") return [r.id, r.nama, r.saldoNormal || "", "", "", fmt(r.saldo)];
      if (r.type === "detail") return [r.tanggal, r.noJurnal, r.ket, fmt(r.debet), fmt(r.kredit), fmt(r.saldo)];
      if (r.type === "total")  return ["Total " + r.nama, "", "", fmt(r.debet), fmt(r.kredit), fmt(r.saldo)];
      return ["Total Mutasi", "", "", fmt(r.debet), fmt(r.kredit), r.saldo === null ? "" : fmt(r.saldo)];
    });
    downloadExcel({ fileName: "BukuBesar_" + (props.title || "Report"), sheet: "Buku Besar", tablePayload: { header: colHeader, body } });
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("BUKU BESAR", 14, 15);
    doc.setFontSize(10);
    const subParts = [];
    if (props.bisnisUnit) subParts.push("Bisnis Unit: " + (props.bisnisUnit === "ALL" ? "Semua Bisnis Unit" : props.bisnisUnit));
    if (periodeLabel) subParts.push("Periode: " + periodeLabel);
    if (subParts.length) doc.text(subParts.join("   |   "), 14, 22);
    const rows = buildRows();
    const body = rows.map((r) => {
      if (r.type === "account") return [r.id, r.nama, r.saldoNormal || "", "", "", fmt(r.saldo)];
      if (r.type === "detail") return [r.tanggal, r.noJurnal, r.ket, fmt(r.debet), fmt(r.kredit), fmt(r.saldo)];
      if (r.type === "total")  return ["Total " + r.nama, "", "", fmt(r.debet), fmt(r.kredit), fmt(r.saldo)];
      return ["Total Mutasi", "", "", fmt(r.debet), fmt(r.kredit), r.saldo === null ? "" : fmt(r.saldo)];
    });
    autoTable(doc, {
      startY: 28, head: [colHeader], body,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
      didParseCell: (data) => {
        const row = rows[data.row.index];
        if (!row) return;
        if (row.type === "account")    { data.cell.styles.fontStyle = "bold"; data.cell.styles.fillColor = [240, 240, 240]; }
        else if (row.type === "total") { data.cell.styles.fontStyle = "bold"; data.cell.styles.fillColor = [189, 215, 238]; }
        else if (row.type === "grandtotal") { data.cell.styles.fontStyle = "bold"; data.cell.styles.fillColor = [93, 173, 226]; data.cell.styles.textColor = [255, 255, 255]; }
        if (data.column.index >= 3) data.cell.styles.halign = "right";
      },
    });
    doc.save("BukuBesar_" + (props.title || "Report") + ".pdf");
  };

  return (
    <>
      <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
        <div className="flex flex-row gap-2">
          <button onClick={handleDownloadExcel} className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
            Download Excel
          </button>
          <button onClick={handleDownloadPDF} className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-500 hover:bg-red-500 hover:text-white rounded shadow">
            Download PDF
          </button>
        </div>
      </div>

      <CardBody className="w-full pt-0">
        <div className="text-center mb-2 mt-2">
          <h2 className="text-lg font-bold text-gray-800 uppercase">Buku Besar</h2>
          {props.bisnisUnit && (
            <p className="text-sm text-gray-600">Bisnis Unit: {props.bisnisUnit === "ALL" ? "Semua Bisnis Unit" : props.bisnisUnit}</p>
          )}
          {periodeLabel && (
            <p className="text-sm text-gray-600">Periode: {periodeLabel}</p>
          )}
        </div>
        {props.data && props.data.data && props.data.data.length === 0 ? (
          <div className="py-10 text-center text-gray-500">
            Tidak ada data untuk filter yang dipilih.
          </div>
        ) : props.data ? (
          <div className="overflow-x-auto relative overflow-y-auto">
            <table className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-4" ref={tableRef}>
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="py-3 px-4">No. Akun</th>
                  <th scope="col" className="py-3 px-4" colSpan={5}>Nama Akun</th>
                </tr>
                <tr>
                  {colHeader.map((h, i) => (
                    <th scope="col" key={"h-" + i} className={"py-3 px-4 " + (i >= 3 ? "text-right" : "")}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.data && props.data.data.map((akun, id) => {
                  let runSaldo = saldoAwalTampil(akun);
                  const saldoAkhirDisplay =
                    saldoAwalTampil(akun) +
                    (parseFloat(akun.TotalDebet || 0) - parseFloat(akun.TotalKredit || 0));
                  return (
                    <React.Fragment key={"akun-" + id}>
                      {/* Baris header akun */}
                      <tr className="bg-gray-100 font-semibold text-gray-800">
                        <td className="py-2 px-4">{akun.DetailAccountID}</td>
                        <td className="py-2 px-4 font-bold" colSpan={3}>
                          {akun.DetailAccount}
                          <span className="ml-2 inline-block px-2 py-0.5 rounded text-xs font-semibold bg-white text-gray-600 border border-gray-300">
                            {normalLabel(akun.SaldoNormal)}
                          </span>
                        </td>
                        <td className="py-2 px-4 text-right text-xs text-gray-500">Saldo Awal</td>
                        <td className="py-2 px-4 text-right">{fmt(saldoAwalTampil(akun))}</td>
                      </tr>
                      {/* Baris detail */}
                      {(akun.Data || []).map((d, idx) => {
                        runSaldo = runSaldo + (parseFloat(d.Debet || 0) - parseFloat(d.Kredit || 0));
                        return (
                          <tr key={"d-" + id + "-" + idx} className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="py-2 px-4 whitespace-nowrap">{new Date(d.Tanggal).toLocaleDateString("id-ID")}</td>
                            <td className="py-2 px-4">{d.AccountingID}</td>
                            <td className="py-2 px-4">{d.Keterangan}</td>
                            <td className="py-2 px-4 text-right">{fmt(d.Debet)}</td>
                            <td className="py-2 px-4 text-right">{fmt(d.Kredit)}</td>
                            <td className="py-2 px-4 text-right">{fmt(runSaldo)}</td>
                          </tr>
                        );
                      })}
                      {/* Baris total per akun */}
                      <tr className="bg-blue-100 font-semibold text-gray-800">
                        <td className="py-2 px-4" colSpan={3}>Total {akun.DetailAccount}</td>
                        <td className="py-2 px-4 text-right">{fmt(akun.TotalDebet)}</td>
                        <td className="py-2 px-4 text-right">{fmt(akun.TotalKredit)}</td>
                        <td className="py-2 px-4 text-right">{fmt(saldoAkhirDisplay)}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
                {/* Total Mutasi periode (Debet & Kredit). Saldo hanya bermakna bila satu akun. */}
                <tr className="bg-blue-300 font-bold text-gray-900">
                  <td className="py-3 px-4" colSpan={3}>Total Mutasi</td>
                  <td className="py-3 px-4 text-right">{fmt(GDebet)}</td>
                  <td className="py-3 px-4 text-right">{fmt(GKredit)}</td>
                  <td className="py-3 px-4 text-right">{showGrandSaldo ? fmt(GSaldoAkhir) : "—"}</td>
                </tr>
              </tbody>
            </table>
            {totalPages > 1 && (
              <div className="flex items-center justify-between mt-4 px-2 text-sm text-gray-600">
                <span>
                  Menampilkan akun {totalCount === 0 ? 0 : startIdx + 1}–{endIdx} dari {totalCount}
                </span>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    disabled={currentPage <= 1}
                    onClick={() => props.onPageChange && props.onPageChange((currentPage - 2) * pageSize)}
                    className="px-3 py-1 border rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
                  >
                    Sebelumnya
                  </button>
                  <span>Halaman {currentPage} dari {totalPages}</span>
                  <button
                    type="button"
                    disabled={currentPage >= totalPages}
                    onClick={() => props.onPageChange && props.onPageChange(currentPage * pageSize)}
                    className="px-3 py-1 border rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
                  >
                    Berikutnya
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function _BukuBesarTableOld_UNUSED(props) {
  const navigate = useNavigate();

  const tableRef = useRef(null);
  let GDebet = 0;
  let GCredit = 0;
  const Yscroll = "";
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <DownloadTableExcel
                filename={"Report_" + props.title + "xlsx"}
                sheet="users"
                currentTableRef={tableRef.current}
              >
                <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                  {" "}
                  Download Excel
                </button>
              </DownloadTableExcel>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  <th scope="col" className="py-3 px-6" key={"Header-"}>
                    {"No. Akun"}
                  </th>
                  <th
                    scope="col"
                    className="py-3 px-6"
                    key={"Header-"}
                    colSpan={6}
                  >
                    {"Nama Akun"}
                  </th>
                </tr>
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.data &&
                  props.data.data.map((Transaksi, id) => {
                    let TotalDebet = 0;
                    let TotalKredit = 0;
                    let SaldoAwal = Transaksi.SaldoAwal;
                    let saldoAkhir = SaldoAwal;
                    return (
                      <>
                        <tr
                          className={"py-4 px-6 font-medium whitespace-nowrap "}
                        >
                          <th
                            scope="row"
                            key={"row" + id}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap "
                            }
                          >
                            {Transaksi.DetailAccountID}
                          </th>
                          <th
                            scope="row"
                            colSpan={2}
                            key={"row" + id}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap "
                            }
                          >
                            {Transaksi.DetailAccount}
                          </th>
                          <th
                            scope="row"
                            key={"row" + id}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap text-right"
                            }
                          >
                            {parseFloat(Transaksi.SaldoAwal).toLocaleString(
                              "in-ID",
                              { maximumFractionDigits: 2 }
                            )}
                          </th>
                          <th
                            scope="row"
                            colSpan={3}
                            key={"row" + id}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap "
                            }
                          ></th>
                        </tr>
                        {Transaksi.Data &&
                          Transaksi.Data.map((detail, idDetail) => {
                            TotalDebet += parseFloat(detail.Debet);
                            TotalKredit += parseFloat(detail.Kredit);

                            GDebet += parseFloat(detail.Debet);
                            GCredit += parseFloat(detail.Kredit);
                            const saldoSebelum = parseFloat(saldoAkhir);
                            saldoAkhir =
                              parseFloat(saldoAkhir) +
                              parseFloat(detail.Debet) -
                              parseFloat(detail.Kredit);

                            return (
                              <tr
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {new Date(detail.Tanggal).toDateString()}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detail.AccountingID}
                                </th>

                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detail.Keterangan}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap text-right"
                                  }
                                >
                                  {saldoSebelum.toLocaleString(
                                    "in-ID",
                                    { maximumFractionDigits: 2 }
                                  )}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap text-right"
                                  }
                                >
                                  {parseFloat(detail.Debet).toLocaleString(
                                    "in-ID",
                                    { maximumFractionDigits: 2 }
                                  )}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap text-right"
                                  }
                                >
                                  {parseFloat(detail.Kredit).toLocaleString(
                                    "in-ID",
                                    { maximumFractionDigits: 2 }
                                  )}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + idDetail}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap text-right"
                                  }
                                >
                                  {parseFloat(
                                    parseFloat(saldoAkhir)
                                  ).toLocaleString("in-ID", {
                                    maximumFractionDigits: 2,
                                  })}
                                </th>
                              </tr>
                            );
                          })}
                        <tr
                          className={
                            "py-4 px-6 font-medium whitespace-nowrap bg-blue-200"
                          }
                        >
                          <th
                            scope="row"
                            key={"row" + id}
                            colSpan={3}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap"
                            }
                          >
                            {"Total"}
                          </th>
                          <th
                            scope="row"
                            key={"row"}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap text-right"
                            }
                          >
                            {parseFloat(Transaksi.SaldoAwal).toLocaleString(
                              "in-ID",
                              { maximumFractionDigits: 2 }
                            )}
                          </th>
                          <th
                            scope="row"
                            key={"row" + id}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap text-right"
                            }
                          >
                            {parseFloat(TotalDebet).toLocaleString("in-ID", {
                              maximumFractionDigits: 2,
                            })}
                          </th>
                          <th
                            scope="row"
                            key={"row" + id}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap text-right"
                            }
                          >
                            {parseFloat(TotalKredit).toLocaleString("in-ID", {
                              maximumFractionDigits: 2,
                            })}
                          </th>
                          <th
                            scope="row"
                            key={"row"}
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap text-right"
                            }
                          >
                            {parseFloat(saldoAkhir).toLocaleString("in-ID", {
                              maximumFractionDigits: 2,
                            })}
                          </th>
                        </tr>
                      </>
                    );
                  })}
                {/*<tr className={"py-4 px-6 font-medium whitespace-nowrap bg-blue-300 text-black"}>*/}
                {/*    <th scope="row"*/}
                {/*        key={"row"}*/}
                {/*        colSpan={3}*/}
                {/*        className={"py-4 px-6 font-medium whitespace-nowrap"}>*/}
                {/*        {"Grand Total"}*/}
                {/*    </th>*/}
                {/*    <th scope="row"*/}
                {/*        key={"row"}*/}
                {/*        className={"py-4 px-6 font-medium whitespace-nowrap text-right"}>*/}
                {/*        {parseFloat(Transaksi.SaldoAwal).toLocaleString('in-ID', {maximumFractionDigits: 2})}*/}
                {/*    </th>*/}
                {/*    <th scope="row"*/}
                {/*        key={"row"}*/}
                {/*        className={"py-4 px-6 font-medium whitespace-nowrap text-right"}>*/}
                {/*        {parseFloat(GDebet).toLocaleString('in-ID', {maximumFractionDigits: 2})}*/}
                {/*    </th>*/}
                {/*    <th scope="row"*/}
                {/*        key={"row"}*/}
                {/*        className={"py-4 px-6 font-medium whitespace-nowrap text-right"}>*/}
                {/*        {parseFloat(GCredit).toLocaleString('in-ID', {maximumFractionDigits: 2})}*/}
                {/*    </th>*/}
                {/*    <th scope="row"*/}
                {/*        key={"row"}*/}
                {/*        className={"py-4 px-6 font-medium whitespace-nowrap text-right"}>*/}
                {/*        {parseFloat(parseFloat(Transaksi.SaldoAwal) + parseFloat(GDebet) - parseFloat(GCredit)).toLocaleString('in-ID', {maximumFractionDigits: 2})}*/}
                {/*    </th>*/}
                {/*</tr>*/}
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function TrialBalanceTable(props) {
  const tableRef = useRef(null);

  const fmt = (val) =>
    parseFloat(val || 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const colHeader = ["No Akun", "Nama Akun", "Saldo Normal", "Saldo Awal", "Debet", "Kredit", "Saldo"];
  const normalLabel = (s) => (String(s).toUpperCase() === "K" ? "Kredit" : "Debit");

  const dataList = [...(props.data?.data || [])].sort((a, b) =>
    String(a.DetailAccountID ?? "").localeCompare(
      String(b.DetailAccountID ?? ""),
      undefined,
      { numeric: true }
    )
  );

  let GSaldoAwal = 0;
  let GDebet = 0;
  let GKredit = 0;
  let GSaldo = 0;
  dataList.forEach((row) => {
    // Grand total = jumlah SALDO BERTANDA apa adanya (Debet positif, Kredit negatif;
    // seed pembukaan sudah dinormalkan bertanda di backend). Dengan begitu grand total
    // Saldo Awal / Saldo Akhir = Σ(Debet−Kredit) seluruh akun = ketimpangan buku, yang
    // NILAINYA SAMA dengan Selisih (Harta − Passiva) pada Neraca. Jangan dikalikan tanda
    // SaldoNormal lagi (akan double-flip dan menghasilkan angka tak bermakna).
    GSaldoAwal += parseFloat(row.SaldoAwal  || 0);
    GDebet  += parseFloat(row.Debet     || 0);
    GKredit += parseFloat(row.Kredit    || 0);
    GSaldo  += parseFloat(row.SaldoAkhir || 0);
  });

  const buildRows = () => {
    const rows = [];
    dataList.forEach((row) => {
      rows.push([
        row.DetailAccountID,
        row.DetailAccount,
        normalLabel(row.SaldoNormal),
        fmt(row.SaldoAwal),
        fmt(row.Debet),
        fmt(row.Kredit),
        fmt(row.SaldoAkhir),
      ]);
    });
    rows.push(["Grand Total", "", "", fmt(GSaldoAwal), fmt(GDebet), fmt(GKredit), fmt(GSaldo)]);
    return rows;
  };

  const handleDownloadExcel = () => {
    const rows = buildRows();
    downloadExcel({
      fileName: "TrialBalance_" + (props.title || "Report"),
      sheet: "Trial Balance",
      tablePayload: { header: colHeader, body: rows },
    });
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Trial Balance", 14, 15);
    if (props.title) { doc.setFontSize(10); doc.text(props.title, 14, 22); }
    const rows = buildRows();
    autoTable(doc, {
      startY: 28,
      head: [colHeader],
      body: rows,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
      didParseCell: (data) => {
        const isLast = data.row.index === rows.length - 1;
        if (isLast) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [93, 173, 226];
          data.cell.styles.textColor = [255, 255, 255];
        }
        if (data.column.index >= 3) data.cell.styles.halign = "right";
      },
    });
    doc.save("TrialBalance_" + (props.title || "Report") + ".pdf");
  };

  return (
    <>
      <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
        <div className="flex flex-row gap-2">
          <button onClick={handleDownloadExcel} className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
            Download Excel
          </button>
          <button onClick={handleDownloadPDF} className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-500 hover:bg-red-500 hover:text-white rounded shadow">
            Download PDF
          </button>
        </div>
      </div>

      <CardBody className="w-full pt-0">
        {props.data ? (
          <div className="overflow-x-auto relative overflow-y-auto">
            <table className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-4" ref={tableRef}>
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {colHeader.map((h, i) => (
                    <th scope="col" key={"h-" + i} className={"py-3 px-4 " + (i >= 3 ? "text-right" : (i === 2 ? "text-center" : ""))}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataList.map((row, id) => (
                  <tr key={"tb-" + id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="py-2 px-4">{row.DetailAccountID}</td>
                    <td className="py-2 px-4">{row.DetailAccount}</td>
                    <td className="py-2 px-4 text-center">{normalLabel(row.SaldoNormal)}</td>
                    <td className="py-2 px-4 text-right">{fmt(row.SaldoAwal)}</td>
                    <td className="py-2 px-4 text-right">{fmt(row.Debet)}</td>
                    <td className="py-2 px-4 text-right">{fmt(row.Kredit)}</td>
                    <td className="py-2 px-4 text-right">{fmt(row.SaldoAkhir)}</td>
                  </tr>
                ))}
                <tr className="bg-blue-300 font-bold text-gray-900">
                  <td className="py-3 px-4" colSpan={3}>Grand Total</td>
                  <td className="py-3 px-4 text-right">{fmt(GSaldoAwal)}</td>
                  <td className="py-3 px-4 text-right">{fmt(GDebet)}</td>
                  <td className="py-3 px-4 text-right">{fmt(GKredit)}</td>
                  <td className="py-3 px-4 text-right">{fmt(GSaldo)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function AccountPayableTable(props) {
  const navigate = useNavigate();

  const tableRef = useRef(null);
  let GA = 0;
  let GB = 0;
  let GC = 0;
  let GD = 0;
  let GE = 0;
  let many = 0;

  if (props.data) {
    many = props.data.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <DownloadTableExcel
                filename={"Report_" + props.title + "xlsx"}
                sheet="users"
                currentTableRef={tableRef.current}
              >
                <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                  {" "}
                  Download Excel
                </button>
              </DownloadTableExcel>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
                <tr>
                  <th colSpan={7}></th>
                  <th
                    scope="col"
                    colSpan={4}
                    className="py-3 px-6 text-center"
                    key={"Header"}
                  >
                    Hari
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.data.data &&
                  props.data.data.map((Transaksi, id) => {
                    if (Transaksi.data)
                      return (
                        <>
                          <tr
                            className={
                              "py-4 px-6 font-medium whitespace-nowrap "
                            }
                          >
                            <th
                              scope="row"
                              key={"row" + id + "-" + id}
                              colSpan={13}
                              className={
                                "py-4 px-6 font-medium whitespace-nowrap bg-blue-200 "
                              }
                            >
                              {Transaksi.SupplierName}
                            </th>
                          </tr>
                          {Transaksi.Data.map((detailTrans, id) => {
                            if (detailTrans.TanggalBayar !== "") {
                              GA += parseFloat(detailTrans.Nominal);
                            }
                            if (
                              detailTrans.Days < 30 &&
                              detailTrans.Days >= 0 &&
                              detailTrans.TanggalBayar === ""
                            ) {
                              GB += parseFloat(detailTrans.Nominal);
                            }
                            if (
                              detailTrans.Days < 60 &&
                              detailTrans.Days > 30
                            ) {
                              GC += parseFloat(detailTrans.Nominal);
                            }
                            if (
                              detailTrans.Days < 90 &&
                              detailTrans.Days > 60
                            ) {
                              GD += parseFloat(detailTrans.Nominal);
                            }
                            if (detailTrans.Days > 90) {
                              GE += parseFloat(detailTrans.Nominal);
                            }
                            return (
                              <tr
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap "
                                }
                              >
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.PurchaseRequisitionID}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.PurchaseOrderID}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.NoBAST}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.TanggalBAST}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.NoDoc}
                                </th>

                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.TanggalBayar}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.TOP + " Hari"}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.TanggalJatuhTempo}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.TanggalBayar !== "" &&
                                    parseFloat(
                                      -detailTrans.Nominal
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.Days < 30 &&
                                    detailTrans.Days >= 0 &&
                                    detailTrans.TanggalBayar === "" &&
                                    parseFloat(
                                      detailTrans.Nominal
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.Days < 60 &&
                                    detailTrans.Days > 30 &&
                                    parseFloat(
                                      detailTrans.Nominal
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.Days < 90 &&
                                    detailTrans.Days > 60 &&
                                    parseFloat(
                                      detailTrans.Nominal
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })}
                                </th>
                                <th
                                  scope="row"
                                  key={"row" + id + "-" + id}
                                  className={
                                    "py-4 px-6 font-medium whitespace-nowrap "
                                  }
                                >
                                  {detailTrans.Days > 90 &&
                                    parseFloat(
                                      detailTrans.Nominal
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })}
                                </th>
                              </tr>
                            );
                          })}
                        </>
                      );
                  })}
                <tr
                  className={
                    "py-4 px-6 font-medium whitespace-nowrap bg-blue-300 text-black"
                  }
                >
                  <th
                    scope="row"
                    key={"row"}
                    colSpan={6}
                    className={"py-4 px-6 font-medium whitespace-nowrap"}
                  >
                    {"Grand Total"}
                  </th>

                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GA).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GB).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GC).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GD).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                  <th
                    scope="row"
                    key={"row"}
                    className={
                      "py-4 px-6 font-medium whitespace-nowrap text-right"
                    }
                  >
                    {parseFloat(GE).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function BukuKasTable(props) {
  const tableRef = useRef(null);

  const fmt = (val) =>
    parseFloat(val || 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const colHeader = ["No. Transaksi", "No. Akun", "Nama Akun", "Tanggal", "Keterangan", "Penerimaan", "Pengeluaran", "Saldo"];

  // Build flat rows for exports
  // NOTE: backend field names are from counterpart-account perspective:
  //   Penerimaan = counterpart Debet = Kas Kredit = cash OUT → display as Pengeluaran
  //   Pengeluaran = counterpart Kredit = Kas Debet  = cash IN  → display as Penerimaan
  const buildRows = () => {
    const rows = [];
    if (!props.data || !props.data.data) return rows;
    props.data.data.forEach((trx) => {
      let runSaldo = parseFloat(trx.SaldoAwal || 0);
      // Account opening row
      rows.push({
        type: "account",
        noTransaksi: "",
        noAkun: trx.DetailAccountID,
        namaAkun: trx.DetailAccount,
        tanggal: "",
        keterangan: "Saldo Awal",
        penerimaan: "",
        pengeluaran: "",
        saldo: runSaldo,
      });
      const totalPenerimaan = parseFloat(trx.TotalPengeluaran || 0); // swapped
      const totalPengeluaran = parseFloat(trx.TotalPenerimaan || 0); // swapped
      const saldoAkhirAkun = runSaldo + totalPenerimaan - totalPengeluaran;
      if (trx.Data) {
        trx.Data.forEach((d) => {
          const pen = parseFloat(d.Pengeluaran || 0); // counterpart Kredit = cash IN = Penerimaan
          const kel = parseFloat(d.Penerimaan || 0);  // counterpart Debet  = cash OUT = Pengeluaran
          runSaldo = runSaldo + pen - kel;
          rows.push({
            type: "detail",
            noTransaksi: d.NoTransaksi,
            noAkun: d.DetailAccountID,
            namaAkun: d.DetailAccount,
            tanggal: new Date(d.Tanggal).toLocaleDateString("id-ID"),
            keterangan: d.Keterangan,
            penerimaan: pen,
            pengeluaran: kel,
            saldo: runSaldo,
          });
        });
      }
      // Total row per account
      rows.push({
        type: "total",
        noTransaksi: "",
        noAkun: "",
        namaAkun: "Total " + trx.DetailAccount,
        tanggal: "",
        keterangan: "",
        penerimaan: totalPenerimaan,
        pengeluaran: totalPengeluaran,
        saldo: saldoAkhirAkun,
      });
    });
    // Grand Total row
    rows.push({
      type: "grandtotal",
      noTransaksi: "",
      noAkun: "",
      namaAkun: "Grand Total",
      tanggal: "",
      keterangan: "",
      penerimaan: TTotalPenerimaan,
      pengeluaran: TTotalPengeluaran,
      saldo: TSaldoAkhir,
    });
    return rows;
  };

  const handleDownloadExcel = () => {
    const rows = buildRows();
    const body = rows.map((r) => [
      r.noTransaksi,
      r.noAkun,
      r.namaAkun,
      r.tanggal,
      r.keterangan,
      r.penerimaan === "" ? "" : parseFloat(r.penerimaan || 0),
      r.pengeluaran === "" ? "" : parseFloat(r.pengeluaran || 0),
      parseFloat(r.saldo || 0),
    ]);
    downloadExcel({
      fileName: "BukuKas_" + (props.title || "Report"),
      sheet: "Buku Kas",
      tablePayload: { header: colHeader, body },
    });
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Report Buku Bank", 14, 15);
    if (props.title) {
      doc.setFontSize(10);
      doc.text(props.title, 14, 22);
    }

    const rows = buildRows();
    const body = rows.map((r) => [
      r.noTransaksi,
      r.noAkun,
      r.namaAkun,
      r.tanggal,
      r.keterangan,
      r.penerimaan === "" ? "-" : fmt(r.penerimaan),
      r.pengeluaran === "" ? "-" : fmt(r.pengeluaran),
      fmt(r.saldo),
    ]);

    autoTable(doc, {
      startY: 28,
      head: [colHeader],
      body,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
      didParseCell: (data) => {
        const row = rows[data.row.index];
        if (!row) return;
        if (row.type === "account") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240];
        } else if (row.type === "total") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [189, 215, 238];
        } else if (row.type === "grandtotal") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [93, 173, 226];
          data.cell.styles.textColor = [255, 255, 255];
        }
        if (data.column.index >= 5) {
          data.cell.styles.halign = "right";
        }
      },
    });

    doc.save("BukuKas_" + (props.title || "Report") + ".pdf");
  };

  // Accumulate grand totals (swap: backend Penerimaan=cashOUT, Pengeluaran=cashIN)
  let TTotalPenerimaan = 0; // displayed Penerimaan = backend TotalPengeluaran
  let TTotalPengeluaran = 0; // displayed Pengeluaran = backend TotalPenerimaan
  let TSaldoAwal = 0;
  let TSaldoAkhir = 0;
  if (props.data && props.data.data) {
    props.data.data.forEach((trx) => {
      const sa = parseFloat(trx.SaldoAwal || 0);
      const tp = parseFloat(trx.TotalPengeluaran || 0); // cash IN
      const tk = parseFloat(trx.TotalPenerimaan || 0);  // cash OUT
      TSaldoAwal += sa;
      TTotalPenerimaan += tp;
      TTotalPengeluaran += tk;
      TSaldoAkhir += sa + tp - tk;
    });
  }

  return (
    <>
      <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
        <div className="flex flex-row gap-2">
          <button
            onClick={handleDownloadExcel}
            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow"
          >
            Download Excel
          </button>
          <button
            onClick={handleDownloadPDF}
            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-500 hover:bg-red-500 hover:text-white rounded shadow"
          >
            Download PDF
          </button>
        </div>
      </div>

      <CardBody className="w-full pt-0">
        {props.data ? (
          <div className="overflow-x-auto relative overflow-y-auto">
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-4"
              ref={tableRef}
            >
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {colHeader.map((h, i) => (
                    <th
                      key={"h-" + i}
                      scope="col"
                      className={"py-3 px-4 " + (i >= 5 ? "text-right" : "")}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.data &&
                  props.data.data.map((trx, id) => {
                    // swap: backend Penerimaan=cashOUT, Pengeluaran=cashIN
                    const trxPenerimaan = parseFloat(trx.TotalPengeluaran || 0);
                    const trxPengeluaran = parseFloat(trx.TotalPenerimaan || 0);
                    const trxSaldoAkhir = parseFloat(trx.SaldoAwal || 0) + trxPenerimaan - trxPengeluaran;
                    let runSaldo = parseFloat(trx.SaldoAwal || 0);
                    return (
                    <React.Fragment key={"trx-" + id}>
                      {/* Account opening row */}
                      <tr className="bg-gray-100 font-semibold text-gray-800">
                        <td className="py-2 px-4"></td>
                        <td className="py-2 px-4">{trx.DetailAccountID}</td>
                        <td className="py-2 px-4 font-bold" colSpan={3}>{trx.DetailAccount}</td>
                        <td className="py-2 px-4 text-right">-</td>
                        <td className="py-2 px-4 text-right">-</td>
                        <td className="py-2 px-4 text-right">{fmt(trx.SaldoAwal)}</td>
                      </tr>
                      {/* Detail rows */}
                      {trx.Data && trx.Data.map((d, idD) => {
                        const pen = parseFloat(d.Pengeluaran || 0); // cashIN  → Penerimaan col
                        const kel = parseFloat(d.Penerimaan  || 0); // cashOUT → Pengeluaran col
                        runSaldo = runSaldo + pen - kel;
                        return (
                        <tr key={"d-" + id + "-" + idD} className="border-b border-gray-200 hover:bg-gray-50">
                          <td className="py-2 px-4">{d.NoTransaksi}</td>
                          <td className="py-2 px-4">{d.DetailAccountID}</td>
                          <td className="py-2 px-4">{d.DetailAccount}</td>
                          <td className="py-2 px-4 whitespace-nowrap">
                            {new Date(d.Tanggal).toLocaleDateString("id-ID")}
                          </td>
                          <td className="py-2 px-4">{d.Keterangan}</td>
                          <td className="py-2 px-4 text-right">{fmt(pen)}</td>
                          <td className="py-2 px-4 text-right">{fmt(kel)}</td>
                          <td className="py-2 px-4 text-right">{fmt(runSaldo)}</td>
                        </tr>
                        );
                      })}
                      {/* Total per account */}
                      <tr className="bg-blue-100 font-semibold text-gray-800">
                        <td className="py-2 px-4" colSpan={5}>Total {trx.DetailAccount}</td>
                        <td className="py-2 px-4 text-right">{fmt(trxPenerimaan)}</td>
                        <td className="py-2 px-4 text-right">{fmt(trxPengeluaran)}</td>
                        <td className="py-2 px-4 text-right">{fmt(trxSaldoAkhir)}</td>
                      </tr>
                    </React.Fragment>
                    );
                  })}
                {/* Grand Total */}
                <tr className="bg-blue-300 font-bold text-gray-900">
                  <td className="py-3 px-4" colSpan={5}>Grand Total</td>
                  <td className="py-3 px-4 text-right">{fmt(TTotalPenerimaan)}</td>
                  <td className="py-3 px-4 text-right">{fmt(TTotalPengeluaran)}</td>
                  <td className="py-3 px-4 text-right">{fmt(TSaldoAkhir)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

// BukuBankReportTable — desain & metode disamakan dengan BukuBesarTable
// (judul + periode, format bilangan bulat, baris "Total Mutasi", pagination server-side),
// namun untuk kolom Buku Bank (Penerimaan/Pengeluaran) dan TANPA Bisnis Unit.
//
// Catatan penamaan field backend (perspektif akun lawan/counterparty):
//   backend Penerimaan = Debet lawan  = Kas/Bank di-Kredit = uang KELUAR → tampil Pengeluaran
//   backend Pengeluaran = Kredit lawan = Kas/Bank di-Debet  = uang MASUK  → tampil Penerimaan
// Karena itu nilai ditukar saat ditampilkan.
export function BukuBankReportTable(props) {
  const tableRef = useRef(null);

  const fmt = (val) =>
    Math.round(parseFloat(val || 0)).toLocaleString("id-ID", { maximumFractionDigits: 0 });

  const namaBulan = [
    "", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember",
  ];
  const periodeLabel =
    props.bulan && props.tahun
      ? `${namaBulan[parseInt(props.bulan, 10)] || props.bulan} ${props.tahun}`
      : "";

  const colHeader = ["No. Transaksi", "No. Akun", "Nama Akun", "Tanggal", "Keterangan", "Penerimaan", "Pengeluaran", "Saldo"];

  // Total mutasi periode (Penerimaan & Pengeluaran, sudah ditukar). Saldo grand total hanya
  // bermakna bila hasil berisi tepat satu akun.
  const akunRows = (props.data && props.data.data) || [];
  let GPenerimaan = 0;
  let GPengeluaran = 0;
  let GSaldoAkhir = 0;
  akunRows.forEach((trx) => {
    GPenerimaan  += parseFloat(trx.TotalPengeluaran || 0); // cash IN
    GPengeluaran += parseFloat(trx.TotalPenerimaan  || 0); // cash OUT
  });
  const showGrandSaldo = akunRows.length === 1;
  if (showGrandSaldo) {
    const sa = parseFloat(akunRows[0].SaldoAwal || 0);
    GSaldoAkhir = sa + parseFloat(akunRows[0].TotalPengeluaran || 0) - parseFloat(akunRows[0].TotalPenerimaan || 0);
  }

  // Pagination level akun (server-side via start/count).
  const pageSize = props.pageSize || maxPageGlobal;
  const totalCount = (props.data && props.data.count) || 0;
  const startIdx = props.start || 0;
  const currentPage = Math.floor(startIdx / pageSize) + 1;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const endIdx = Math.min(startIdx + pageSize, totalCount);

  const buildRows = () => {
    const rows = [];
    if (!props.data || !props.data.data) return rows;
    props.data.data.forEach((trx) => {
      let runSaldo = parseFloat(trx.SaldoAwal || 0);
      rows.push({ type: "account", noTransaksi: "", noAkun: trx.DetailAccountID, namaAkun: trx.DetailAccount, tanggal: "", ket: "Saldo Awal", pen: "", kel: "", saldo: runSaldo });
      (trx.Data || []).forEach((d) => {
        const pen = parseFloat(d.Pengeluaran || 0); // cash IN  → Penerimaan
        const kel = parseFloat(d.Penerimaan  || 0); // cash OUT → Pengeluaran
        runSaldo = runSaldo + pen - kel;
        rows.push({ type: "detail", noTransaksi: d.NoTransaksi, noAkun: d.DetailAccountID, namaAkun: d.DetailAccount, tanggal: new Date(d.Tanggal).toLocaleDateString("id-ID"), ket: d.Keterangan, pen, kel, saldo: runSaldo });
      });
      const tp = parseFloat(trx.TotalPengeluaran || 0);
      const tk = parseFloat(trx.TotalPenerimaan || 0);
      rows.push({ type: "total", noTransaksi: "", noAkun: "", namaAkun: "Total " + trx.DetailAccount, tanggal: "", ket: "", pen: tp, kel: tk, saldo: parseFloat(trx.SaldoAwal || 0) + tp - tk });
    });
    rows.push({ type: "grandtotal", noTransaksi: "", noAkun: "", namaAkun: "Total Mutasi", tanggal: "", ket: "", pen: GPenerimaan, kel: GPengeluaran, saldo: showGrandSaldo ? GSaldoAkhir : null });
    return rows;
  };

  const handleDownloadExcel = () => {
    const rows = buildRows();
    const body = rows.map((r) => [
      r.type === "total" || r.type === "grandtotal" ? r.namaAkun : r.noTransaksi,
      r.noAkun, r.type === "total" || r.type === "grandtotal" ? "" : r.namaAkun,
      r.tanggal, r.ket,
      r.pen === "" ? "" : fmt(r.pen),
      r.kel === "" ? "" : fmt(r.kel),
      r.saldo === null ? "" : fmt(r.saldo),
    ]);
    downloadExcel({ fileName: "BukuBank_" + (props.title || "Report"), sheet: "Buku Bank", tablePayload: { header: colHeader, body } });
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("BUKU BANK", 14, 15);
    doc.setFontSize(10);
    if (periodeLabel) doc.text("Periode: " + periodeLabel, 14, 22);
    const rows = buildRows();
    const body = rows.map((r) => [
      r.type === "total" || r.type === "grandtotal" ? r.namaAkun : r.noTransaksi,
      r.noAkun, r.type === "total" || r.type === "grandtotal" ? "" : r.namaAkun,
      r.tanggal, r.ket,
      r.pen === "" ? "-" : fmt(r.pen),
      r.kel === "" ? "-" : fmt(r.kel),
      r.saldo === null ? "" : fmt(r.saldo),
    ]);
    autoTable(doc, {
      startY: 28, head: [colHeader], body,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
      didParseCell: (data) => {
        const row = rows[data.row.index];
        if (!row) return;
        if (row.type === "account")    { data.cell.styles.fontStyle = "bold"; data.cell.styles.fillColor = [240, 240, 240]; }
        else if (row.type === "total") { data.cell.styles.fontStyle = "bold"; data.cell.styles.fillColor = [189, 215, 238]; }
        else if (row.type === "grandtotal") { data.cell.styles.fontStyle = "bold"; data.cell.styles.fillColor = [93, 173, 226]; data.cell.styles.textColor = [255, 255, 255]; }
        if (data.column.index >= 5) data.cell.styles.halign = "right";
      },
    });
    doc.save("BukuBank_" + (props.title || "Report") + ".pdf");
  };

  return (
    <>
      <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
        <div className="flex flex-row gap-2">
          <button onClick={handleDownloadExcel} className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
            Download Excel
          </button>
          <button onClick={handleDownloadPDF} className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-500 hover:bg-red-500 hover:text-white rounded shadow">
            Download PDF
          </button>
        </div>
      </div>

      <CardBody className="w-full pt-0">
        <div className="text-center mb-2 mt-2">
          <h2 className="text-lg font-bold text-gray-800 uppercase">Buku Bank</h2>
          {periodeLabel && (
            <p className="text-sm text-gray-600">Periode: {periodeLabel}</p>
          )}
        </div>
        {props.data && props.data.data && props.data.data.length === 0 ? (
          <div className="py-10 text-center text-gray-500">
            Tidak ada data untuk filter yang dipilih.
          </div>
        ) : props.data ? (
          <div className="overflow-x-auto relative overflow-y-auto">
            <table className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-4" ref={tableRef}>
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {colHeader.map((h, i) => (
                    <th scope="col" key={"h-" + i} className={"py-3 px-4 " + (i >= 5 ? "text-right" : "")}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.data && props.data.data.map((trx, id) => {
                  let runSaldo = parseFloat(trx.SaldoAwal || 0);
                  const trxPenerimaan = parseFloat(trx.TotalPengeluaran || 0);
                  const trxPengeluaran = parseFloat(trx.TotalPenerimaan || 0);
                  const trxSaldoAkhir = parseFloat(trx.SaldoAwal || 0) + trxPenerimaan - trxPengeluaran;
                  return (
                    <React.Fragment key={"trx-" + id}>
                      {/* Baris pembuka akun (Saldo Awal) */}
                      <tr className="bg-gray-100 font-semibold text-gray-800">
                        <td className="py-2 px-4"></td>
                        <td className="py-2 px-4">{trx.DetailAccountID}</td>
                        <td className="py-2 px-4 font-bold" colSpan={2}>{trx.DetailAccount}</td>
                        <td className="py-2 px-4 text-right text-xs text-gray-500">Saldo Awal</td>
                        <td className="py-2 px-4 text-right">-</td>
                        <td className="py-2 px-4 text-right">-</td>
                        <td className="py-2 px-4 text-right">{fmt(trx.SaldoAwal)}</td>
                      </tr>
                      {/* Baris detail */}
                      {(trx.Data || []).map((d, idx) => {
                        const pen = parseFloat(d.Pengeluaran || 0); // cash IN
                        const kel = parseFloat(d.Penerimaan  || 0); // cash OUT
                        runSaldo = runSaldo + pen - kel;
                        return (
                          <tr key={"d-" + id + "-" + idx} className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="py-2 px-4">{d.NoTransaksi}</td>
                            <td className="py-2 px-4">{d.DetailAccountID}</td>
                            <td className="py-2 px-4">{d.DetailAccount}</td>
                            <td className="py-2 px-4 whitespace-nowrap">{new Date(d.Tanggal).toLocaleDateString("id-ID")}</td>
                            <td className="py-2 px-4">{d.Keterangan}</td>
                            <td className="py-2 px-4 text-right">{fmt(pen)}</td>
                            <td className="py-2 px-4 text-right">{fmt(kel)}</td>
                            <td className="py-2 px-4 text-right">{fmt(runSaldo)}</td>
                          </tr>
                        );
                      })}
                      {/* Baris total per akun */}
                      <tr className="bg-blue-100 font-semibold text-gray-800">
                        <td className="py-2 px-4" colSpan={5}>Total {trx.DetailAccount}</td>
                        <td className="py-2 px-4 text-right">{fmt(trxPenerimaan)}</td>
                        <td className="py-2 px-4 text-right">{fmt(trxPengeluaran)}</td>
                        <td className="py-2 px-4 text-right">{fmt(trxSaldoAkhir)}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
                {/* Total Mutasi periode. Saldo hanya bermakna bila satu akun. */}
                <tr className="bg-blue-300 font-bold text-gray-900">
                  <td className="py-3 px-4" colSpan={5}>Total Mutasi</td>
                  <td className="py-3 px-4 text-right">{fmt(GPenerimaan)}</td>
                  <td className="py-3 px-4 text-right">{fmt(GPengeluaran)}</td>
                  <td className="py-3 px-4 text-right">{showGrandSaldo ? fmt(GSaldoAkhir) : "—"}</td>
                </tr>
              </tbody>
            </table>
            {totalPages > 1 && (
              <div className="flex items-center justify-between mt-4 px-2 text-sm text-gray-600">
                <span>
                  Menampilkan akun {totalCount === 0 ? 0 : startIdx + 1}–{endIdx} dari {totalCount}
                </span>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    disabled={currentPage <= 1}
                    onClick={() => props.onPageChange && props.onPageChange((currentPage - 2) * pageSize)}
                    className="px-3 py-1 border rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
                  >
                    Sebelumnya
                  </button>
                  <span>Halaman {currentPage} dari {totalPages}</span>
                  <button
                    type="button"
                    disabled={currentPage >= totalPages}
                    onClick={() => props.onPageChange && props.onPageChange(currentPage * pageSize)}
                    className="px-3 py-1 border rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
                  >
                    Berikutnya
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

const BukuNeracaGenerator = (props) => (
  <tr className={"py-4 px-6 font-medium whitespace-nowrap   text-black"}>
    <th
      scope="row"
      key={"row"}
      className={"py-4 px-6 font-medium whitespace-nowrap"}
    >
      {props.nama}
    </th>
    <th
      scope="row"
      key={"row"}
      className={"py-4 px-6 font-medium whitespace-nowrap text-right"}
    >
      {parseFloat(props.transaksi[props.subkey][props.keys]).toLocaleString(
        "in-ID",
        { maximumFractionDigits: 2 }
      )}
    </th>
  </tr>
);

// buildNeracaRows menyusun daftar baris Neraca (label + Current/Previous/selisih/
// persentase, plus subtotal per Main Account & Total Passiva) dari payload API.
// Dipakai bersama oleh komponen tabel BukuNeraca (render) dan halaman report
// (export Excel/PDF) — satu sumber rumus & urutan baris, sama seperti
// buildLabaRugiRows di atas.
export function buildNeracaRows(payload) {
  // Neraca komparatif: backend mengirim
  // { CurrentPeriod, PreviousPeriod, Groups: [{ Group, MainAccountID, MainAccount,
  //   Items:[{Name,Previous,Current,Change,Percentage}], TotalPrevious, TotalCurrent, ... }] }
  const p = payload || {};
  const groups = p.Groups || [];
  const currentPeriod = p.CurrentPeriod || "Bulan Berjalan";
  const previousPeriod = p.PreviousPeriod || "Bulan Sebelumnya";

  // Persentase perubahan: Change / |Previous| * 100 (basis 0 => 0%). Samakan dgn backend.
  const pctChange = (change, base) =>
    base === 0 ? 0 : (change / Math.abs(base)) * 100;

  // Subtotal per Main Account (Harta/Hutang/Modal): jumlah TotalCurrent/TotalPrevious
  // semua Group yang berbagi MainAccountID sama. Total Harta = Main Account '1'; Total
  // Passiva = seluruh Main Account SELAIN '1' (Hutang + Modal).
  const mainTotals = {}; // MainAccountID -> { name, prev, cur }
  groups.forEach((g) => {
    const id = g.MainAccountID || "";
    if (!mainTotals[id]) mainTotals[id] = { name: g.MainAccount || "", prev: 0, cur: 0 };
    mainTotals[id].prev += g.TotalPrevious || 0;
    mainTotals[id].cur += g.TotalCurrent || 0;
  });
  const harta = mainTotals["1"] || { prev: 0, cur: 0 };
  let passivaPrev = 0;
  let passivaCur = 0;
  Object.keys(mainTotals).forEach((id) => {
    if (id !== "1") {
      passivaPrev += mainTotals[id].prev;
      passivaCur += mainTotals[id].cur;
    }
  });

  const rows = [];
  const header = (label) => rows.push({ type: "header", label });
  const spacer = () => rows.push({ type: "spacer" });
  // type bervariasi (data/groupTotal/mainTotal/passivaTotal) supaya render tabel bisa
  // memberi warna baris yang berbeda persis seperti versi lama, tanpa mengubah rumus.
  const row = (type, label, current, previous) => {
    const c = current || 0;
    const pr = previous || 0;
    // Baris data (bukan subtotal) dgn nilai 0 di kedua periode disembunyikan
    // agar tabel tak penuh baris kosong; subtotal (groupTotal/mainTotal/
    // passivaTotal) tetap selalu tampil, sama seperti buildLabaRugiRows.
    if (type === "data" && c === 0 && pr === 0) return;
    rows.push({
      type,
      label,
      current: c,
      previous: pr,
      change: c - pr,
      pct: pctChange(c - pr, pr),
    });
  };

  groups.forEach((group, gi) => {
    header(group.Group || "");
    (group.Items || []).forEach((item) => {
      row("data", item.Name, item.Current, item.Previous);
    });
    row("groupTotal", "Total " + (group.Group || ""), group.TotalCurrent, group.TotalPrevious);

    // Subtotal per Main Account — tampil setelah Group terakhir dari Main Account tsb.
    // Contoh: Total Harta, Total Hutang, Total Modal.
    const isLastOfMain =
      gi === groups.length - 1 ||
      (groups[gi + 1] || {}).MainAccountID !== group.MainAccountID;
    if (isLastOfMain && mainTotals[group.MainAccountID || ""]) {
      const mt = mainTotals[group.MainAccountID || ""];
      row("mainTotal", "Total " + (mt.name || group.Group), mt.cur, mt.prev);
    }

    // Total Passiva (Hutang + Modal) — di paling akhir tabel.
    if (gi === groups.length - 1) {
      row("passivaTotal", "Total Passiva (Hutang + Modal)", passivaCur, passivaPrev);
    }

    spacer();
  });

  return {
    rows,
    currentPeriod,
    previousPeriod,
    hartaCur: harta.cur,
    hartaPrev: harta.prev,
    passivaCur,
    passivaPrev,
  };
}

export function BukuNeraca(props) {
  const tableRef = useRef(null);
  let many = 0;
  if (props.data) {
    many = props.data.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }

  // Nilai negatif (akun bersaldo abnormal / kontra / defisit) disajikan dalam tanda
  // kurung sesuai konvensi akuntansi, mis. -2.694.971 => "(2.694.971)".
  const formatNominal = (value) => {
    const n = parseFloat(value || 0);
    const s = Math.abs(n).toLocaleString("in-ID", {
      maximumFractionDigits: 2,
    });
    return n < 0 ? "(" + s + ")" : s;
  };

  // Format persentase perubahan (backend mengirim angka, mis. -12.5 => "-12,50%").
  const formatPercentage = (value) =>
    parseFloat(value || 0).toLocaleString("in-ID", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + "%";

  // Warna selisih: naik hijau, turun merah, nol netral.
  const changeColor = (value) => {
    if (value > 0) return "text-green-600";
    if (value < 0) return "text-red-600";
    return "text-black";
  };

  const cellCls = "py-3 px-6 font-medium whitespace-nowrap text-right";

  // Warna baris per jenis — persis konvensi versi lama: header/Total Group biru-500,
  // Total per Main Account biru-800, Total Passiva indigo-900, data biasa hitam.
  const rowCls = {
    header: "bg-blue-500 text-white",
    groupTotal: "bg-blue-500 text-white",
    mainTotal: "bg-blue-800 text-white",
    passivaTotal: "bg-indigo-900 text-white",
  };

  if (props.data) {
    const { rows, currentPeriod, previousPeriod, hartaCur, passivaCur } = buildNeracaRows(
      props.data.data
    );
    const headCls =
      "py-3 px-6 font-semibold whitespace-nowrap text-right text-gray-700 uppercase text-xs";
    // #2 Uji keseimbangan: Total Harta harus sama dengan Total Passiva (Hutang + Modal).
    // Memakai periode BERJALAN (Current): Laba/(Rugi) Periode Berjalan sudah dimasukkan ke
    // ekuitas periode berjalan, sehingga Harta seharusnya = Passiva pada periode ini.
    const selisih = hartaCur - passivaCur;
    const seimbang = Math.abs(selisih) < 1;
    return (
      <>
        <CardBody className="w-full pt-0 ">
          {props.data ? (
            <>
              <div
                className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
              >
                <table
                  className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                  ref={tableRef}
                >
                  <thead className="border-b-2 border-gray-200">
                    <tr>
                      <th className={"py-3 px-6 font-semibold whitespace-nowrap text-left text-gray-700 uppercase text-xs"}>
                        Uraian
                      </th>
                      <th className={headCls}>{currentPeriod}</th>
                      <th className={headCls}>{previousPeriod}</th>
                      <th className={headCls}>Naik / (Turun)</th>
                      <th className={headCls}>%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, i) => {
                      if (r.type === "spacer") {
                        return (
                          <tr key={i} className="whitespace-nowrap text-white">
                            <th className="py-2 px-6"></th>
                            <td className={cellCls}></td>
                            <td className={cellCls}></td>
                            <td className={cellCls}></td>
                            <td className={cellCls}></td>
                          </tr>
                        );
                      }
                      if (r.type === "header") {
                        return (
                          <tr key={i} className={"whitespace-nowrap " + rowCls.header}>
                            <th scope="row" className="py-3 px-6 font-semibold whitespace-nowrap">
                              {r.label}
                            </th>
                            <th className={cellCls}></th>
                            <th className={cellCls}></th>
                            <th className={cellCls}></th>
                            <th className={cellCls}></th>
                          </tr>
                        );
                      }
                      const isTotal = r.type !== "data";
                      return (
                        <tr
                          key={i}
                          className={"whitespace-nowrap " + (isTotal ? rowCls[r.type] : "text-black")}
                        >
                          <th
                            scope="row"
                            className={
                              "py-3 px-6 whitespace-nowrap " +
                              (isTotal ? "font-bold uppercase" : "font-medium")
                            }
                          >
                            {r.label}
                          </th>
                          <td className={cellCls + (isTotal ? " font-bold" : "")}>
                            {formatNominal(r.current)}
                          </td>
                          <td className={cellCls + (isTotal ? " font-bold" : "")}>
                            {formatNominal(r.previous)}
                          </td>
                          <td
                            className={
                              cellCls + (isTotal ? " font-bold" : " " + changeColor(r.change))
                            }
                          >
                            {formatNominal(r.change)}
                          </td>
                          <td
                            className={
                              cellCls + (isTotal ? " font-bold" : " " + changeColor(r.change))
                            }
                          >
                            {formatPercentage(r.pct)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* #2 Panel indikator keseimbangan Neraca (Harta vs Passiva) */}
              <div className="px-6 pb-6 pt-2">
                <div
                  className={
                    "rounded-lg border p-4 " +
                    (seimbang
                      ? "border-green-300 bg-green-50"
                      : "border-red-300 bg-red-50")
                  }
                >
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <span className="font-bold uppercase text-sm text-gray-700">
                      Uji Keseimbangan Neraca ({currentPeriod})
                    </span>
                    <span
                      className={
                        "px-3 py-1 rounded-full text-xs font-bold " +
                        (seimbang ? "bg-green-600 text-white" : "bg-red-600 text-white")
                      }
                    >
                      {seimbang ? "SEIMBANG" : "TIDAK SEIMBANG"}
                    </span>
                  </div>
                  <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
                    <div className="flex justify-between sm:block">
                      <span className="text-gray-500">Total Harta</span>
                      <div className="font-semibold text-right sm:text-left">
                        {formatNominal(hartaCur)}
                      </div>
                    </div>
                    <div className="flex justify-between sm:block">
                      <span className="text-gray-500">
                        Total Passiva (Hutang + Modal)
                      </span>
                      <div className="font-semibold text-right sm:text-left">
                        {formatNominal(passivaCur)}
                      </div>
                    </div>
                    <div className="flex justify-between sm:block">
                      <span className="text-gray-500">Selisih</span>
                      <div
                        className={
                          "font-bold text-right sm:text-left " +
                          (seimbang ? "text-green-700" : "text-red-700")
                        }
                      >
                        {formatNominal(selisih)}
                      </div>
                    </div>
                  </div>
                  {!seimbang && (
                    <p className="mt-3 text-xs text-red-700">
                      Harta tidak sama dengan Passiva. Selisih ini umumnya berasal dari
                      jurnal yang tidak seimbang (Debet ≠ Kredit) atau saldo pembukaan yang
                      belum lengkap — perlu ditinjau pada data jurnal.
                    </p>
                  )}
                </div>
              </div>
            </>
          ) : (
            <Skeltons />
          )}
        </CardBody>
      </>
    );
  } else {
    return <></>;
  }
}

// buildLabaRugiRows menyusun daftar baris Laba Rugi (label + Current/Previous/
// selisih/persentase) dari payload API. Dipakai bersama oleh komponen tabel
// LabaRugi (render) dan halaman report (export Excel/PDF) — satu sumber rumus
// & urutan baris.
export function buildLabaRugiRows(payload) {
  const p = payload || {};
  // Dukung format komparatif (Current/Previous) & fallback format lama (single period).
  const cur = p.Current || p || {};
  const prev = p.Previous || {};
  const currentPeriod = p.CurrentPeriod || "Bulan Berjalan";
  const previousPeriod = p.PreviousPeriod || "Bulan Sebelumnya";

  const f = (t, sub, key) => parseFloat((t && t[sub] && t[sub][key]) || 0);
  const fld = (sub, key) => (t) => f(t, sub, key);
  const pctChange = (change, base) =>
    base === 0 ? 0 : (change / Math.abs(base)) * 100;

  const jmlPendapatanUsaha = (t) => f(t, "PendapatanUsaha", "JumlahPendapatanUsaha");
  const jmlBebanLangsung = (t) => f(t, "BebanLangsung", "JumlahBebanLangsung");
  const jmlBebanAdm = (t) => f(t, "BebanAdministrasi", "JumlahBebanAdministrasi");
  const jmlDiluarUsaha = (t) =>
    f(t, "PendapatanDiluarUsaha", "JumlahPendapatanDiluarUsaha");
  const jmlBebanPajak = (t) => f(t, "BebanPajak", "JumlahBebanPajak");
  const labaKotor = (t) => jmlPendapatanUsaha(t) - jmlBebanLangsung(t);
  const labaUsaha = (t) => labaKotor(t) - jmlBebanAdm(t);
  // Laba (Rugi) Sebelum Pajak = LABA (RUGI) USAHA + Jumlah Pendapatan (Beban) Di Luar Usaha
  const labaSebelumPajak = (t) => labaUsaha(t) + jmlDiluarUsaha(t);
  const labaSetelahPajak = (t) => labaSebelumPajak(t) - jmlBebanPajak(t);

  const rows = [];
  const header = (title) => rows.push({ type: "header", label: title });
  const spacer = () => rows.push({ type: "spacer" });
  const data = (label, getter, opts) => {
    const o = opts || {};
    const c = getter(cur);
    const pr = getter(prev);
    // Sub uraian dgn nilai 0 di kedua periode disembunyikan agar tabel tak
    // penuh baris kosong; baris total/bold (mis. Jumlah/LABA) tetap tampil.
    if (!o.bold && c === 0 && pr === 0) return;
    rows.push({
      type: "data",
      label,
      current: c,
      previous: pr,
      change: c - pr,
      pct: pctChange(c - pr, pr),
      bold: !!o.bold,
      total: !!o.bold,
    });
  };

  header("PENDAPATAN USAHA");
  data("Pendapatan usaha jasa", fld("PendapatanUsaha", "PendapatanUsaha"));
  data("Pendapatan usaha jasa lainnya", fld("PendapatanUsaha", "PendapatanUsahaLain"));
  data("Jumlah Pendapatan Usaha", fld("PendapatanUsaha", "JumlahPendapatanUsaha"), { bold: true });
  spacer();

  header("BEBAN LANGSUNG");
  data("Beban karyawan dan tenaga kerja", fld("BebanLangsung", "BebanKaryawan"));
  data("Beban operasi pelabuhan", fld("BebanLangsung", "BebanOperasi"));
  data("Beban akomodasi", fld("BebanLangsung", "BebanAkomodasi"));
  data("Beban kepelabuhan", fld("BebanLangsung", "BebanPelabuhan"));
  // Beban Administrasi digabung ke baris ini (bukan baris terpisah lagi) —
  // dua sub-akun sumber, satu baris tampilan.
  data(
    "Beban administrasi dan umum",
    (t) => f(t, "BebanLangsung", "BebanUmum") + f(t, "BebanLangsung", "BebanAdministrasi")
  );
  data("Beban kantor", fld("BebanLangsung", "BebanKantor"));
  data("Beban transportasi", fld("BebanLangsung", "BebanTransportasi"));
  data("Beban penyusutan aktiva tetap", fld("BebanLangsung", "BebanPenyusutan"));
  data("Beban amortisasi", fld("BebanLangsung", "BebanAmortisasi"));
  data("Beban marketing", fld("BebanLangsung", "BebanMarketing"));
  data("Jumlah Beban Langsung", fld("BebanLangsung", "JumlahBebanLangsung"), { bold: true });
  data("LABA KOTOR", labaKotor, { bold: true });
  spacer();

  header("BEBAN ADMINISTRASI DAN UMUM");
  data("Beban karyawan", fld("BebanAdministrasi", "BebanKaryawan"));
  data("Beban kantor", fld("BebanAdministrasi", "BebanKantor"));
  data("Beban transportasi", fld("BebanAdministrasi", "BebanTransportasi"));
  data("Beban profesional", fld("BebanAdministrasi", "BebanProfesional"));
  data("Beban umum lainnya", fld("BebanAdministrasi", "BebanUmumLain"));
  data("Beban penyusutan aktiva tetap", fld("BebanAdministrasi", "BebanPenyusutanAktiva"));
  data("Beban amortisasi", fld("BebanAdministrasi", "BebanAmortisasi"));
  data("Jumlah Beban Administrasi dan Umum", fld("BebanAdministrasi", "JumlahBebanAdministrasi"), { bold: true });
  data("LABA (RUGI) USAHA", labaUsaha, { bold: true });
  spacer();

  header("PENDAPATAN (BEBAN) DILUAR USAHA");
  data("Pendapatan diluar usaha", fld("PendapatanDiluarUsaha", "PendapatanDiluarUsaha"));
  data("Beban diluar usaha", fld("PendapatanDiluarUsaha", "BebanDiluarUsaha"));
  data("Jumlah Pendapatan (Beban) Di Luar Usaha", fld("PendapatanDiluarUsaha", "JumlahPendapatanDiluarUsaha"), { bold: true });
  data("Laba (Rugi) Sebelum Pajak", labaSebelumPajak, { bold: true });
  spacer();

  header("BEBAN PAJAK");
  data("Pajak kini", fld("BebanPajak", "PajakKini"));
  data("Pajak tangguhan", fld("BebanPajak", "PajakTangguhan"));
  data("Jumlah Beban Pajak", fld("BebanPajak", "JumlahBebanPajak"), { bold: true });
  data("LABA (RUGI) SETELAH PAJAK", labaSetelahPajak, { bold: true });

  return { rows, currentPeriod, previousPeriod };
}

export function LabaRugi(props) {
  const tableRef = useRef(null);
  if (!props.data || !props.data.data) {
    return <Skeltons />;
  }

  const { rows, currentPeriod, previousPeriod } = buildLabaRugiRows(props.data.data);

  // Nilai negatif disajikan dalam tanda kurung sesuai konvensi akuntansi (seragam dgn Neraca),
  // mis. -2.691.971.530 => "(2.691.971.530)".
  const fmt = (v) => {
    const n = parseFloat(v || 0);
    const s = Math.abs(n).toLocaleString("in-ID", { maximumFractionDigits: 2 });
    return n < 0 ? "(" + s + ")" : s;
  };
  const fmtPct = (v) =>
    parseFloat(v || 0).toLocaleString("in-ID", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + "%";
  const changeColor = (v) =>
    v > 0 ? "text-green-600" : v < 0 ? "text-red-600" : "text-black";

  const cellCls = "py-3 px-6 whitespace-nowrap text-right";
  const headCls =
    "py-3 px-6 font-semibold whitespace-nowrap text-right text-gray-700 uppercase text-xs";
  const totalCls = "bg-brown-200 text-black";

  return (
    <>
      <CardBody className="w-full pt-0 ">
        <div className="overflow-x-auto relative overflow-y-auto">
          <table
            className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
            ref={tableRef}
          >
            <thead className="border-b-2 border-gray-200">
              <tr>
                <th className="py-3 px-6 font-semibold whitespace-nowrap text-left text-gray-700 uppercase text-xs">
                  Uraian
                </th>
                {/* Bulan Berjalan tampil LEBIH DULU, baru Bulan Sebelumnya
                    (posisi ditukar dari sebelumnya atas permintaan). */}
                <th className={headCls}>{currentPeriod}</th>
                <th className={headCls}>{previousPeriod}</th>
                <th className={headCls}>Naik / (Turun)</th>
                <th className={headCls}>%</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => {
                if (r.type === "spacer") {
                  return (
                    <tr key={i} className="whitespace-nowrap text-white">
                      <th className="py-2 px-6"></th>
                      <td className={cellCls}></td>
                      <td className={cellCls}></td>
                      <td className={cellCls}></td>
                      <td className={cellCls}></td>
                    </tr>
                  );
                }
                if (r.type === "header") {
                  return (
                    <tr key={i} className="whitespace-nowrap bg-blue-300 text-black">
                      <th scope="row" className="py-3 px-6 font-bold whitespace-nowrap uppercase">
                        {r.label}
                      </th>
                      <td className={cellCls}></td>
                      <td className={cellCls}></td>
                      <td className={cellCls}></td>
                      <td className={cellCls}></td>
                    </tr>
                  );
                }
                const nameCls =
                  "py-3 px-6 whitespace-nowrap " + (r.bold ? "font-bold" : "font-medium");
                return (
                  <tr
                    key={i}
                    className={"whitespace-nowrap " + (r.total ? totalCls : "text-black")}
                  >
                    <th scope="row" className={nameCls}>{r.label}</th>
                    <td className={cellCls}>{fmt(r.current)}</td>
                    <td className={cellCls}>{fmt(r.previous)}</td>
                    <td className={cellCls + " " + changeColor(r.change)}>{fmt(r.change)}</td>
                    <td className={cellCls + " " + changeColor(r.change)}>{fmtPct(r.pct)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardBody>
    </>
  );
}

export function DynamicTablePurchasereq(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);

  useEffect(() => {
    if (currentPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2);
      setPagingTwo(currentPage - 1);
      setPagingThree(currentPage);
      setPagingFour(currentPage + 1);
      setPagingFive(currentPage + 2);
    }
  }, [currentPage]);

  let many = 0;
  if (dataMajor) {
    many = dataMajor.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master &&
              (props.types !== "PC" ||
                props.types !== "gudang" ||
                props.types !== "penerimaan-barang") && (
                <button
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                  onClick={() => props.OnClick({})}
                >
                  Tambah +
                </button>
              )}
          </div>
          <div className="flex flex-row w-96">
            <SearchBarSmall
              text={"Cari " + props.name}
              funcs={props.menuController}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
        Show
        <div className="inline-block relative w-16 mx-1">
          <select
            value={currentCount}
            onChange={(e) => {
              setCurrentCount(e.target.value);
              setCurrentPage(1);
              props.updateCount(e.target.value);
            }}
            className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={-1}>All</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        Data
      </div>

      <CardBody className="w-full pt-0 ">
        {dataMajor ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataMajor.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      key={`row-${id}`}
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                        let texts = detail[props.header[idRow]["key"]];
                        if (props.header[idRow]["modifiers"] === "Date") {
                          texts = new Date(
                            detail[props.header[idRow]["key"]]
                          ).toLocaleDateString("ID");
                        }

                        if (props.header[idRow]["modifiers"] !== "Button") {
                          return (
                            <th
                              scope="row"
                              key={`cell-${id}-${idRow}`}
                              className={
                                "py-4 px-6 font-medium whitespace-nowrap " +
                                (props.header[idRow]["modifiers"] === "Number "
                                  ? "text-right"
                                  : "text-left ") +
                                (props.header[idRow]["modifiers"] !== "Status"
                                  ? "text-black"
                                  : "text-main-100")
                              }
                            >
                              {texts}
                            </th>
                          );
                        } else {
                          return (
                            <th
                              scope="row"
                              key={`btn-${id}-${idRow}`}
                              className="py-4 px-6 font-medium whitespace-nowrap"
                            >
                              {detail["STATUS"] !== "Menunggu Approval" && (
                                <a
                                  onClick={(e) => {
                                    props.editor(detail[props.primarykey]);
                                  }}
                                  className={
                                    "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                  }
                                >
                                  {"Edit"}
                                </a>
                              )}
                            </th>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <nav
              className="flex justify-between items-center pt-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                Showing{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {currentPage === 1
                    ? currentPage
                    : (currentPage - 1) * props.count}
                  -
                  {currentPage * props.count > count
                    ? count
                    : currentPage * props.count}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {count}
                </span>
              </span>
              <ul className="inline-flex items-center -space-x-px">
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                        props.updatePage(currentPage - 1);
                      }
                    }}
                    className="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
                {props.maxPage > 0 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingOne);
                        props.updatePage(pagingOne);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingOne ? selected : notSelected
                      }`}
                    >
                      {pagingOne}
                    </a>
                  </li>
                )}
                {props.maxPage > 1 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingTwo);
                        props.updatePage(pagingTwo);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingTwo ? selected : notSelected
                      }`}
                    >
                      {pagingTwo}
                    </a>
                  </li>
                )}
                {props.maxPage > 2 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingThree);
                        props.updatePage(pagingThree);
                      }}
                      href="#"
                      aria-current="page"
                      className={`${
                        currentPage === pagingThree ? selected : notSelected
                      }`}
                    >
                      {pagingThree}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 3 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFour);
                        props.updatePage(pagingFour);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFour ? selected : notSelected
                      }`}
                    >
                      {pagingFour}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 4 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFive);
                        props.updatePage(pagingFive);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFive ? selected : notSelected
                      }`}
                    >
                      {pagingFive}
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => {
                      if (currentPage < props.maxPage) {
                        setCurrentPage(currentPage + 1);
                        props.updatePage(currentPage + 1);
                      }
                    }}
                    href="#"
                    className="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}

export function DynamicTableApproval(props) {
  const tableRef = useRef(null);
  const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
  const selected =
    "z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white";
  const notSelected =
    "py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";
  const breakpoint = 620;
  let dataMajor = [];
  let count = 0;
  if (props.data) {
    dataMajor = props.data.data || [];
    count = props.data.count || 0;
  }
  const width = React.useState(window.innerWidth);
  const [pagingOne, setPagingOne] = React.useState(1);
  const [pagingTwo, setPagingTwo] = React.useState(2);
  const [pagingThree, setPagingThree] = React.useState(3);
  const [pagingFour, setPagingFour] = React.useState(4);
  const [pagingFive, setPagingFive] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(props.currentPage);

  useEffect(() => {
    if (currentPage < 3) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (props.maxPage < 5) {
      setPagingOne(1);
      setPagingTwo(2);
      setPagingThree(3);
      setPagingFour(4);
      setPagingFive(5);
    } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
      setPagingOne(props.maxPage - 4);
      setPagingTwo(props.maxPage - 3);
      setPagingThree(props.maxPage - 2);
      setPagingFour(props.maxPage - 1);
      setPagingFive(props.maxPage);
    } else {
      setPagingOne(currentPage - 2);
      setPagingTwo(currentPage - 1);
      setPagingThree(currentPage);
      setPagingFour(currentPage + 1);
      setPagingFive(currentPage + 2);
    }
  }, [currentPage]);

  let many = 0;
  if (dataMajor) {
    many = dataMajor.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }
  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master &&
              (props.types !== "PC" ||
                props.types !== "gudang" ||
                props.types !== "penerimaan-barang") && (
                <button
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                  onClick={() => props.OnClick({})}
                >
                  Tambah +
                </button>
              )}
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
        Show
        <div className="inline-block relative w-16 mx-1">
          <select
            value={currentCount}
            onChange={(e) => {
              setCurrentCount(e.target.value);
              setCurrentPage(1);
              props.updateCount(e.target.value);
            }}
            className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={-1}>All</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        Data
      </div>

      <CardBody className="w-full pt-0 ">
        {dataMajor ? (
          <div
            className={"overflow-x-auto relative overflow-y-auto " + Yscroll}
          >
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-orange-600 uppercase bg-gray-50 dark:bg-gray-700 dark:text-orange-400">
                <tr>
                  <th scope="col" className="py-3 px-6" key={"Header-a"}>
                    Menu
                  </th>
                  <th scope="col" className="py-3 px-6" key={"Header-b"}>
                    Bagian
                  </th>
                  <th scope="col" className="py-3 px-6" key={"Header-c"}>
                    Pemberi Approval
                  </th>
                  <th scope="col" className="py-3 px-6" key={"Header-d"}>
                    Ubah
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataMajor.map((detail, id) => {
                  var classOdd =
                    "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                  if (id % 2 === 0)
                    classOdd =
                      "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                  return (
                    <tr
                      className={classOdd}
                      onClick={() => {
                        if (!props.Master) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                        <th
                          scope="row"
                          key={"row" + id + "a"}
                          className={"py-4 px-6 font-medium whitespace-nowrap "}
                        >
                          {detail.Group === "PriceComparationBesar"
                            ? "PriceComparation > 10jt"
                            : detail.Group}
                        </th>
                        <th
                          scope="row"
                          key={"row" + id + "b"}
                          className={"py-4 px-6 font-medium whitespace-nowrap "}
                        >
                          {detail.NamaBagian}
                        </th>
                        <th
                          scope="row"
                          key={"row" + id + "c"}
                          className={"py-4 px-6 font-medium whitespace-nowrap "}
                        >
                          {detail.Detail &&
                            detail.Detail.map(
                              (dataDetail, primary) => dataDetail.Nama + ", "
                            )}
                        </th>
                        <th
                          scope="row"
                          key={"row" + id + "d"}
                          className={"py-4 px-6 font-medium whitespace-nowrap "}
                        >
                          <a
                            onClick={(e) => {
                              props.editor(detail);
                            }}
                            className={
                              "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                            }
                          >
                            {"Edit"}
                          </a>
                        </th>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <nav
              className="flex justify-between items-center pt-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                Showing{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {currentPage === 1
                    ? currentPage
                    : (currentPage - 1) * props.count}
                  -
                  {currentPage * props.count > count
                    ? count
                    : currentPage * props.count}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900 dark:text-white">
                  {count}
                </span>
              </span>
              <ul className="inline-flex items-center -space-x-px">
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                        props.updatePage(currentPage - 1);
                      }
                    }}
                    className="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
                {props.maxPage > 0 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingOne);
                        props.updatePage(pagingOne);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingOne ? selected : notSelected
                      }`}
                    >
                      {pagingOne}
                    </a>
                  </li>
                )}
                {props.maxPage > 1 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingTwo);
                        props.updatePage(pagingTwo);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingTwo ? selected : notSelected
                      }`}
                    >
                      {pagingTwo}
                    </a>
                  </li>
                )}
                {props.maxPage > 2 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingThree);
                        props.updatePage(pagingThree);
                      }}
                      href="#"
                      aria-current="page"
                      className={`${
                        currentPage === pagingThree ? selected : notSelected
                      }`}
                    >
                      {pagingThree}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 3 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFour);
                        props.updatePage(pagingFour);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFour ? selected : notSelected
                      }`}
                    >
                      {pagingFour}
                    </a>
                  </li>
                )}
                {width > breakpoint && props.maxPage > 4 && (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentPage(pagingFive);
                        props.updatePage(pagingFive);
                      }}
                      href="#"
                      className={`${
                        currentPage === pagingFive ? selected : notSelected
                      }`}
                    >
                      {pagingFive}
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => {
                      if (currentPage < props.maxPage) {
                        setCurrentPage(currentPage + 1);
                        props.updatePage(currentPage + 1);
                      }
                    }}
                    href="#"
                    className="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <Skeltons />
        )}
      </CardBody>
    </>
  );
}
